'use strict'
exports.default = {
  common: {
    zh: '中国語',
    tw: '繫体中文',
    ja: '日本語',
    en: '英語',
    ko: '韓国語',
    title: 'コンソル管理システム',
    exit: '終了',
    search: '検索',
    tel: '電話番号',
    address: '住所',
    scenicSpotAreaSelection: '観光地の地域選択',
    inputRequiredTip: '観光地名を入力してください',
    edit: '編集',
    delete: '削除',
    recommend: 'おすすめに設定',
    pay: '支払い',
    printOrder: '印刷',
    download: 'ダウンロード',
    cancelRecommend: 'おすすめ設定を削除',
    cancel: 'キャンセル',
    confirm: '確認',
    submit: '確認',
    searchMore: '詳細を見る',
    prompt: '注意',
    basicInfo: '基本情報',
    day: '日',
    hour: '時間',
    minute: '分',
    second: '秒'
  },
  title: {
    supplement: '利用手順補充',
    addDining: '商品追加（レストラン）',
    balanceSetting: '库存价格',
    productPriceNumber: '在庫価格',
    productState: '商品審査',
    productAll: '全部',
    productStated: '審査待ち',
    productNotState: '審査失敗',
    orderReport: '予約管理',
    orderDetail: '予約詳細',
    scenicSpotList: '観光地管理',
    addScenicSpot: '観光スポット追加',
    editScenicSpot: '観光スポット編集',
    scenicSpotDetail: '観光スポットの詳細',
    popularCities: '人気目的地管理',
    addHotCity: '人気目的地を追加',
    editHotCity: '人気目的地を編集',
    productManager: '商品管理',
    pdfFilesManage: 'PDFデータ管理',
    supplyManageProduct: '商品販売管理',
    tocDistributorManageProduct: 'TOC商品販売管理',
    pdfBatchList: 'バッチリスト',
    bulkPurchaseList: '一括購入リスト',
    bulkPurchaseDetail: '一括購入詳細',
    submitAndPayOrderBatch: '一括仕入れ',
    batchPdfFilesList: 'バッチファイルリスト',
    addPdfFiles: 'PDFデータフォルダ追加',
    importPdf: 'PDFデータ導入',
    pdfFiles: 'PDFファイル',
    DiningDetail: 'レストラン商品詳細',
    financeStatement: '精算管理',
    statementDetail: '明細書詳細',
    warehouse: '倉庫管理',
    ticketDepot: 'チケット倉庫管理',
    addTicketDepot: 'チケット倉庫を新規追加',
    importTicket: '倉庫に導入',
    pinTicket: '認証出庫',
    pinTicketMagn: '認証出庫管理',
    trades: '取引明細',
    record: '残金引出履歴',
    counter: 'カウンター管理',
    addCounter: 'カウンター追加',
    editCounter: 'カウンター編集',
    liaison: '連絡先管理',
    addLiaison: '連絡先追加',
    editLiaison: '連絡先編集',
    updatePDFfiles: 'PDFデータフォルダ編集',
    importThirdSystemProduct: '商品導入管理',
    productLogList: '商品变更記録',
    productLogDetail: '商品变更の詳細',
    productLanguageLogList: '商品变更記録',
    productLanguageLogDetail: '商品の多言語変更の詳細',
    bannerManage: 'バナー管理'
  },
  lable: {
    translation: 'AI翻訳',
    translationing: 'AI翻訳中...',
    translationTip: '翻訳するデータがありません',
    isOnline: 'リリースするかどうか',
    hotCity: '人気目的地',
    cityName: '目的地名',
    cityPicture: '目的地画像',
    languageType: '言語',
    sort: '並び順',
    sortTip: '数値が小さいほど上位に表示されます',
    onlineTip: 'オフラインにするとクライアントに表示されなくなります',
    hotType: '人気タイプ',
    type1: '人気地域',
    type2: '人気目的地',
    type3: '人気のランドマーク',
    addProduct: '商品を追加',
    productInformation: '商品情報',
    price: '価格',
    tags: 'タグ',
    productList: '商品リスト',
    bannerTitle: 'バナーメインタイトル',
    bannerSubTitle: 'バナーサブタイトル',
    bannerImages: 'バナー画像',
    selectLogType: '記録タイプ',
    selectLogType_1: '基礎フィールド',
    selectLogType_2: '多言語フィールド',
    inputProductId: 'キーワード',
    inputProductId_placeholder: '商品番号を入力',
    customerDataType: 'お客様資料タイプ',
    customerDataInfo: 'お客様情報',
    chooseProductLanguage: '商品言語',
    noDataForLanguage: 'まだデータがありません。別の言語を選択してください',
    newOrderEmail: '注文通知メール',
    batchStatus: 'バッチ状態',
    proofPath: 'チケットリンク',
    pinTicketNum: '認証数',
    KlookTicketCanbeUsedDateTBList: ' から六ヶ月以内',
    KlookTicketCanbeUsedDate: ' から六ヶ月以内、同じ価額種類がある日は有効であります',
    QuantityMismatch: '認証数と予約購入数が不一致です、認証しますか',
    importProduct: '商品導入',
    system: '接続先システム',
    chooseSystem: '接続先システムを選択してください',
    klook: 'KLOOK',
    link: 'LINK',
    thirdNum: '接続先の商品番号',
    enterThirdNum: '接続先の商品番号を入力してください',
    thirdProductTime: '時間：',
    timeTips: '時間帯を入力してください（1～24）',
    haveInventory: '在庫あり',
    noInventory: '在庫なし',
    travlerFirstName: '名前',
    travlerFamilyName: '姓氏',
    travlerCall: '敬称',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: 'ミスター',
    Ms: 'ミズ',
    Miss: 'ミス',
    Mrs: 'ミセス',
    duration: 'コース時間',
    travellers: '勧め人数',
    voucherUsage: 'チケット利用方法',
    voucherTypeDesc: 'チケット種類',
    voucherValidity: 'チケット有効期間',
    redemptionProcess: '認証手順',
    transportation: '交通手段',
    insiderTips: '注意事項',
    joinAstrict: '参加制限',
    demand: '要件',
    packageOptions: 'セット商品説明',
    itinerary: 'コース説明',
    additionalInformation: '付加情報',
    meetUpLocation: '集合説明',
    pickUpLocation: '引き取り場所',
    surcharge: 'タイムオーバー費用',
    location: 'アドレス',
    submitOrderTip: '当該商品は特殊商品であります。予約送信する場合には、購入総金額が直ちに自動的に残高から引き落とすことになります。ご注意ください。',
    submitOrderBatch: '購入内容をご確認ください。予約送信する場合には、購入総金額が自動的にAGTの残高から引き落とすことになります。ご注意ください。',
    location_placeholder: 'アドレスを入力してください',
    duration_placeholder: 'イベント時間帯を入力してください',
    productConfirmType_placeholder: '商品確認方法を入力してください',
    transportation_placeholder: '交通手段を入力してください',
    voucherTypeDesc_placeholder: 'チケット種類を入力してください',
    voucherUsage_placeholder: 'チケット使用方法を入力してください',
    voucherValidity_placeholder: 'チケット有効期限を入力してください',
    pickUpLocation_placeholder: '引き取り場所を入力してください',
    redemptionProcess_placeholder: 'アドレスを入力してください',
    packageOptions_placeholder: 'セット商品説明を入力してください',
    itinerary_placeholder: 'コース説明を入力してください',
    additionalInformation_placeholder: '付加情報を入力してください',
    surcharge_placeholder: 'タイムオーバー費用を入力してください',
    insiderTips_placeholder: '注意事項を入力してください',
    updateType: '種類編集',
    updateFloatPrice: 'フロート価格',
    shareQrCode: 'QRコードをシェア',
    setQrCode: '二次元コードの設定',
    addCoupon: 'クーポン新規追加',
    couponName: 'クーポン名称',
    couponAmount: 'クーポン金額',
    couponOrder: 'クーポン取引',
    couponCode: 'クーポンコード',
    addCouponCode: 'クーポンコード新規追加',
    downloadCouponCode: 'クーポンコードをダウンロード',
    batchDelete: '一括削除',
    downloadNow: '{cnt}枚を新規追加いたしました。ダウンロードしますか。',
    tipMessage1: '名称を入力してください',
    examine: '販売店審査',
    revenueManagement: '収益管理',
    revenueDetail: '収益管理',
    cashManager: '現金引き出し管理',
    productState: '状態を選択してください',
    orderNum1: 'ソート順',
    netError: 'この商品はサプライヤー側で既に下線されています。',
    updateProduct: '更新',
    addQrCode: 'QR코드 추가',
    pleasechoice: '選択してください',
    identity: '身分証明書',
    studentId: '学生証',
    officerId: '士官証明',
    passport: 'パスポート',
    residence: '戸籍謄本',
    hongKongandMacaopass: '香港とマカオの通行証',
    cellsyndrome: '台湾人証明書',
    identificationNumber: '証明書の番号',
    children: '子供の生年月日',
    addressinformation: '連絡先',
    expressaddress: '住所',
    postalCode: '郵便番号',
    suborderinformation: '分支注文情報',
    subordersId: '分支注文書ID',
    qxzfbcplx: '商品種類を選択してください',
    selectTreeId: '请选择产品类型',
    ticketType: '種類',
    jtrticketType: '種類',
    productPriceTypeSetting: '価格カテゴリー設定',
    batchPriceRuleSetting: 'まとめて設定',
    specificDatePriceSetting: '日付別設定',
    currentProducts: '当商品：',
    currentProducts_saleDate: '販売期間：',
    unlimited: '制限なし',
    setProductInventoryAndPrice: 'まとめて料金と在庫を設定',
    setProductPriceType: '商品価格カテゴリーの設定',
    serialNumber: '番号',
    period: '時間帯',
    timelimit: '時間帯範囲',
    selectDateRange: '期間選択',
    selectTimeRange: '時間帯選択',
    inventory: '在庫',
    purchasePrice: '仕入価格',
    jtrDistributionPrice: 'B toB価格',
    stockNum: '時間帯在庫',
    distributionPrice: '卸価格',
    marketPrice: '市場価格',
    retailPrice: '推奨価格',
    operating: '操作',
    delete: '削除',
    chargeback: '予約取り消し',
    addTimePeriod: '時間帯を追加',
    reset: 'リセット',
    save: '保存',
    goBack: '戻る',
    confirm: '確認',
    confirmOrder: '予約確認',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR注文情报を確認する',
    refuse: '予約拒否',
    cancelOrder: '予約取り消し',
    requestCancel: 'キャンセル申請',
    specialRequestRefund: '特殊予約取り消し',
    requestRefund: '返金申請',
    makeSure: '確認',
    cancel: 'キャンセル',
    productName: '商品名',
    scene: '场次',
    dataSource: 'データソース',
    selectDistributor: 'AGT選択',
    authorizedMerchant: '権限設定済みAGT',
    businessName: '販売店名',
    priceFloatRange: 'AGT特別卸値（通常価格の増減計算）',
    distributorNameOrNumber: '販売店名/番号',
    distributorNumber: 'AGT番号',
    distributorName: 'AGT名',
    changeValidTime: '有効期間変更',
    // suoCountry: '所属城市',
    suoCountry: 'キーワード',
    suoCountrys: 'キーワード',
    productNameOrId: '商品名/番号',
    productNameOrIds: '商品名/番号',
    productNameOrIdRemark: '商品名/番号/備考/タグ',
    productDiff: '種類',
    productDiffs: '種類',
    confirmMethod: '確認方法',
    managerArea: '管理地域',
    productCode: '商品番号',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '人気の目的地',
    confirmMethods: '確認方法',
    confirmMethodss: '確認方法',
    managerAreas: '管理地域',
    different: '種類',
    number: '人数',
    status: '状態',
    ticketType0: '電子チケット',
    ticketType1: '実物券',
    ticketType2: '体験',
    ticketType22: '体験',
    ticketType3: 'ツアー',
    ticketType33: 'ツアー',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIMカード',
    ticketType6: 'レストラン',
    ticketType66: 'レストラン',
    ticketType7: '交通',
    ticketType77: '交通',
    ticketType8: 'お得セット商品',
    ticketType88: 'お得セット商品',
    ticketType9: '夜行バス',
    ticketType99: '夜行バス',
    jtrticketType0: '入場券',
    jtrticketType1: 'お得セット',
    jtrticketType2: 'ツアー',
    jtrticketType3: '路線',
    jtrticketType12: '前売り',
    isOnlinePay0: '販売停止',
    isOnlinePay1: 'オンライン',
    isOnlinePay2: 'オンライン決済（先払い）',
    isOnlinePay3: 'ホテルカウンター現金払い（返佣）',
    confirmType0: '自動確認',
    confirmType00: '自動確認',
    confirmType1: '二次確認',
    confirmType11: '二次確認',
    confirmType12: '二次確認',
    confirmType2: '',
    productSource0: 'JPH商品',
    productSource1: '接続先商品',
    status0: '審査待ち',
    status1: '審査通過',
    status2: '審査失敗',
    status3: '販売停止',
    status4: '下書き',
    online: 'オンライン',
    checkAll: '詳細',
    faverite0: 'おすすめ',
    faverite1: 'おすすめしません',
    toldAllLeft: '説明：利用日の',
    toldAllMiddle: '日前',
    toldAllMiddles: '日前',
    toldAllRight: 'までに予約',
    orderEmergentTag: '緊急処理',
    orderUncertainTag: '確認待ち',
    orderConfirmedTag: '予約済',
    orderCancellingTag: 'キャンセル処理中',
    orderCanceledTag: 'キャンセル済',
    orderCompletedTag: 'スキャン済',
    orderExpiredTag: '有効期切れ',
    orderPaymentTag: '支払い済み（JTR）',
    orderRefundedRequestTag: '返金申請済み（JTR）',
    orderRefundedTag: '返金済',
    orderUnpaidTag: '未支払い',
    otherSelection: 'その他のフィルター',
    remark: '備考',
    createRoleRemark: '備考',
    productHighlights: 'セールスポイント',
    currentState: '予約状態',
    youHave: '残り',
    processOrder: '予約を処理する',
    toPayOrder: '予約を支払う',
    OrderHistory: '操作履歴',
    orderDisExplain: '予約説明(AGTのみ表示)',
    orderDisExplains: '備考(施設のみ表示)',
    CustomersInvisible: '予約についての確認連絡',
    SupplierInvisible: 'お客様の伝言',
    addRemark: '備考を追加',
    addMessage: 'メッセージを追加',
    addExplain: '備考入力',
    confirmation: 'この注文を確認しますか',
    confirmationPdf: 'このPDFを無効化しますか',
    confirmationticket: 'この実物券を無効化しますか？',
    specialRefundConfirm: '返金確認後、全額がAGTに返還されます、確認しますか确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '返金拒むと、予約は続きます',
    DeleteConfirmation: '削除しますか',
    refusal: '予約を断りますか',
    voucherPath: 'チケットリンク',
    messageInfo: '予約詳細情報',
    orderID: '予約番号',
    sonOrderID: '予約番号',
    jtrOrderId: 'チャネル番号',
    orderSource: '予約元',
    useDate: '指定利用日',
    sonProduct: '商品',
    useDate1: '指定利用日',
    useDates: '指定利用日',
    travelDate: '利用日',
    createTime: '予約時間',
    endTravelDate: '終了時間',
    arrivedTime: '到着時間',
    touristRemarks: 'お客様メモ',
    reserveNum: '予約数',
    linkMan: '名前',
    warnning1: '本人確認が必要のため、本名しか入力しないでください。',
    linkPhone: '電話番号',
    linkEmail: 'メールボックス',
    linkAddress: '宅便アドレス',
    linkCode: '郵便番号',
    linkCreditType: '連絡者証明書類型',
    linkoptionA: '身分証明',
    linkoptionB: 'パスポート',
    linkCreditNo: '連絡者証明書番号',
    customerUseDate: '利用日',
    customerTravelDate: '利用日',
    customerEndTravelDate: '利用最終日',
    customerArriveTime: '到着日付',
    customerGetTicType: 'チケット受け取り方法',
    customerGetTicType0: '無料',
    customerGetTicType1: '宅便料金',
    distributor: 'AGT',
    PDFSendingMode: 'PDF電子チケットの送付方法',
    productPrice: '商品価格',
    Purchase: '仕入価格',
    distributionPriceToc: 'AGTtoC卸価格',
    distributionPriceSum: 'AGTtoC総計価格',
    productSalePrice: '商品特別価格',
    productMinPrice: '最低価額(展示用)',
    productTcPrice: '商品特別価格',
    buyNum: '購入数',
    seatName: '時間帯名称',
    jtrAppendNum: '追加数',
    primarynum: '注文数量',
    cancelNum: '取り消し数',
    orderCnt: '成功数',
    totalAmount: '合計額',
    customerInfo: 'お客様情報',
    customerName: 'お名前',
    cusEmail: 'メールアドレス',
    Email: 'メールアドレス',
    receiveDate: '引換日',
    returnDate: '返却日付',
    FileImport: 'ファイル導入',
    upload: 'アップロード',
    onlyUpload: 'アップロードできるのは',
    noMoreThan: 'ファイルだけであり、最大サイズは',
    generateOrder: '予約作成',
    thisOrder: 'この予約は',
    hasConsumed: 'お客様がすでに利用した',
    noData: 'データなし',
    viewName: '観光地名',
    viewLocal: '所在地',
    viewAddress: '観光地住所',
    viewPicture: '観光地の写真',
    viewRemark: '観光地の備考',
    viewTelephone: '観光地の電話番号',
    payOrder: '予約を支払う',
    jtrpayOrder: 'jtr決済予約',
    jtrAppend: 'jtr追加予約',
    operated: '操作',
    productSource: '商品所属元',
    searchType: '検索の種類を選択',
    searchType1: '予約番号',
    searchType2: '商品名',
    searchType3: 'お客様名前',
    searchType4: '',
    searchType5: 'お客様メールアドレス',
    searchType6: 'チャネル番号',
    searchType7: 'タグ',
    system1: 'EASYGOシステム',
    system2: '2cycleシステム',
    system3: '乐天系统',
    productConfirmType: '確認方法',
    reserve: '予約',
    isOnlinePay: '支払い方法',
    startDate: '観光始め時間',
    maxNum: '最多注文量',
    minNum: '最少受け入れ人数',
    startNum: '最低注文量',
    isExpress: '宅便は可能かどうか',
    yesExpress: '支持',
    noExpress: '支持しない',
    expressPrice: '宅便料金',
    priceStartDate: '価格開始時間',
    priceEndDate: '価格終了時間',
    priceDate: '価格開始/価格終了',
    soldNum: '販売数',
    soldNumSort: '販売数',
    ticketCount: '売上数',
    sourceType: 'ソース',
    sourceType1: 'JPH施設',
    sourceType2: 'JTR施設',
    sourceType3: 'KLOOK施設',
    supplySourceType1: 'JPH商品',
    supplySourceType2: 'JTR商品',
    supplySourceType3: 'KLOOK商品',
    supplySourceType4: '2CYCLE商品',
    supplySourceType5: 'LINK',
    haveNoReserve: '売り切れ',
    upTime: 'オンライン時間',
    productReserve: '商品予約',
    pictureDown: '写真素材ダウンロード',
    voideDown: '動画素材ダウンロード',
    fileDepot: 'ファイル倉庫',
    takeView: '観光地',
    productNumber: '商品番号',
    supplier: 'サプライヤー',
    operator: '運営者',
    useFate: '利用手順',
    supplement: '利用手順補充',
    supplements: '利用手順補充',
    ticketTypeName: 'チケットタイプ',
    isOnlinepay: '決済方法',
    num: '件',
    nums: '件',
    num01: '件',
    money: '￥',
    serviceLanguage: '対応言語',
    productPeople: '年齢制限など',
    takeTimeDesc: '営業時間説明',
    productUpTime: '商品販売期間',
    diningTime: '利用時間帯',
    diningPeople: '利用人数',
    useTime: '利用時間',
    trafficMethod: 'アクセス',
    moneyContant: '料金に含まれる',
    moneyNotContant: '料金に含まれない',
    priceOrFloat: '価格/在庫',
    diningDescription: '商品内容',
    picture: '写真',
    titles: 'タイトル',
    numberBuy: '数量',
    reserveDescription: '予約説明',
    beforeDay: '何日前',
    minteBefore: '何分前に予約',
    usingDate: '有効期間',
    canBeUseDate: '有効期限',
    canBeUseDate1: '有効期限',
    returnMethod: '返金設定',
    returnDescription: '返金説明',
    reserveNotice: '予約注意事項',
    importantNote: 'ご注意',
    userNote: '使用説明',
    changeMethod: 'チケット引換及びカウンター',
    comnicationPeople: '連絡先',
    contionMen: '連絡係',
    telphone: '連絡方法',
    welcomeData: '対応時間',
    productDescription: '商品説明',
    dangerConcationMen: '緊急連絡先',
    productPackageContainDetail: 'セット商品詳細情報',
    productPackageDetail: 'セット商品詳細',
    productContainDetail: '商品詳細情報',
    SIMSize: 'SIMカードサイズ',
    netCover: 'カバー範囲',
    threeGNetCover: '3G通信量',
    fourGNetCover: '4G高速通信量',
    parts: '部品',
    SIMProductDetail: 'SIMカード商品詳細情報',
    WIFIProductDetail: 'wifi商品詳細情報',
    tourProductDetail: '1Day観光/数泊の商品詳細情報',
    ticketProductDetail: 'チケット情報',
    packageProductDetail: 'お得セット商品情報',
    freeTourDetail: '自由ツアー情報',
    routeDetail: '路線情報',
    advanceDetail: '前売り情報',
    toursTime: '行程時間数',
    travelStyle: '行程種類',
    trafficStyle: '交通機関',
    startCourtyOrEnd: '出発都市/目的地',
    jtrPeopleNum: '商品に含む成人数 ',
    jtrChildrenNum: '商品に含む子供数',
    peopleNum: '催行最小人数',
    buyMessage: 'ショッピング情報',
    tourDetail: 'コース詳細',
    giveClass: '無料キャンペーン',
    trafficProductDetail: '交通商品詳細情報',
    ybProductDetail: '夜行バス商品詳細情報',
    // takePomStyle: '1.引換方法',
    takePomStyle: '',
    longWord: '予約が成功な場合、プラットフォームより指定されたメールアドレスに予約成功のメールを送信する。そのメールにある認証コード又はQRコードを下記カウンターに提示し、実物券を引換してください。',
    // canBeTakePom: '2.引換可能カウンター',
    canBeTakePom: '',
    counterLink: '引換カウンター',
    orderMessages: '新しい連絡',
    saleTimes: '営業時間',
    telphoneCommicta: '連絡先電話番号：',
    jtrOrderVaildType0: 'お客様の指定利用日当日のみ有効',
    jtrOrderVaildType1: 'お客様の予約日延期',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: 'お客様の指定利用日延期',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '指定日当日のみ有効',
    ordervaildType12: '予約日から',
    ordervaildType1: '日以内に有効',
    ordervaildType2: '予約日から指定日',
    ordervaildType3: '有効',
    ordervaildType4: '指定利用日から',
    ordervaildType5: '指定利用日から指定日',
    ordervaildType55: '指定利用日から指定日',
    ordervaildType6: '指定日',
    ordervaildType7: 'から',
    ordervaildType8: '以内有效',
    ordervaildType9: '指定利用日の',
    ordervaildType10: '日前から指定利用日の',
    ordervaildType11: '日まで有効',
    ordervaildType13: '日以内に有効',
    ordervaildType14: '有効',
    ordervaildType15: '以内有效',
    orderRefundType0: '変更キャンセル不可',
    orderRefundType1: '利用前いつでもキャンセル可能',
    orderRefundType4: '利用日',
    orderRefundType5: '日前は返金可能',
    orderRefundType3: '期限切れなので、キャッシュバックできない！',
    orderRefundType7: '予約は返金不可能です！',
    orderRefundType6: '未支払い予約は返金できません',
    eleDetail: '電子チケット詳細',
    jtrticketDetail: 'チケット商品情報',
    entityDetail: '実物券詳細',
    experienceDetail: '体験詳細',
    detail3: 'ツアー詳細',
    detail4: 'WI-FI詳細',
    detail5: 'SIMカード詳細',
    detail6: 'レストラン詳細',
    detail7: '交通詳細',
    detail8: 'お得セット詳細',
    eleDetailPreview: '電子チケットのプレビュー',
    entityDetailPreview: '実物券のプレビュー',
    experienceDetailPreview: '体験のプレビュー',
    tourPreview: '1Day観光/数泊のプレビュー',
    wifiPreview: 'WIFI商品プレビュー',
    simPreview: 'SIMカード商品プレビュー',
    diningPreview: 'レストラン商品プレビュー',
    trafficPreview: '交通商品プレビュー',
    packagePreview: 'セット商品プレビュー',
    spread: '枚',
    diningDetail: 'レストラン商品詳細',
    diningDetailPreview: 'レストランのプレビュー',
    orderStatus: '予約状態',
    floatPrice: '浮动价格',
    ifOnLine: '販売状態',
    onLine: 'オンライン',
    isEdit: 'オンライン待ち',
    offLine: 'オフライン',
    SalesSituation: '販売状況',
    orderNum: '件',
    copyOperating: 'コピー',
    graphicEditing: '图文编辑',
    revoke: '審査キャンセル',
    modify: '編集',
    jtrModifylanguage: '多言語編集',
    more: 'その他',
    distributionAuthorization: '販売権設定',
    specialPrice: '特別価格設定',
    specialPriceSet: 'AGT特別価格設定',
    distributionRange: '販売権の範囲の設定',
    distributionRangeAll: '全てのAGTが販売可能',
    distributionRangeYes: '指定AGTのみ販売可能',
    distributionRangeNo: '指定AGT以外は販売可能',
    merchantRangeAll: '全てのAGT',
    merchantRangeYes: '指定AGT',
    merchantRangeNo: '指定AGT以外',
    specifiedRange: '指定範囲',
    account: 'ID',
    PDFSendWay: 'PDF送付方法',
    PDFOnLine: 'オンライン',
    PDFOffLine: 'オフライン',
    connectInformation: '連絡先',
    dialogCancel: 'キャンセル',
    dialogSure: '確認',
    dialogSave: '上書き保存',
    selectProCategory: '追加したい商品の種類を選択してください',
    ticketsMessage: 'QRコードにより直接入場/利用する施設のチケット。',
    ticketsMessage2: '指定場所でQRコードにより実物券と引換し、利用する施設のチケット。',
    ticketsMessage3: 'QRコードにより現地での引換、もしくは直接入場/利用する施設のチケット。',
    ticketsMessage4: 'バスツアー、チャーター商品',
    ticketsMessage5: 'ポケットWi-Fi商品',
    ticketsMessage6: 'プリペイドカード商品',
    ticketsMessage7: '席予約、コース料理予約商品',
    ticketsMessage8: '交通券、チャーター商品',
    ticketsMessage9: 'お得な組み合わせ商品',
    ticketsMessage10: '夜行バス商品',
    serialNumbers: '番号',
    belongArea: '地域',
    connectWay: '連絡先',
    purchasingSituation: '購入状況',
    proStatus: '商品状態',
    ifOnlineStatus: '販売状態',
    today: '本日利用は予約可',
    tomorrow: '明日利用は予約可',
    oldPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    checkPassword: 'パスワードの再確認',
    limitDay: 'その他',
    limitDays: 'その他',
    auditCannot: '審査失敗理由：',
    notMust: '制限なし',
    breakfast: '朝食',
    lunch: '昼食',
    afternoonTea: 'アフタヌーンティー',
    dinner: '夕食',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '夜食',
    singleMeal: 'シングルセット',
    doubleMeal: 'ダブルセット',
    thirdMeal: '3~4人分',
    fiveMeal: '5~10人分',
    tenMeal: '10人以上',
    haveMustData: '具体的な時間帯',
    common: '合わせて',
    species: '種類',
    dayBefore: '日前',
    applyToRefund: '(ローカル時間)前までに返金申請可',
    updateNotAudited: '審査失敗理由を編集',
    pleaseEnterAudited: '審査失敗の理由を入力してください',
    updateSuccess: '更新できました！',
    updateFliture: '更新に失敗しました！',
    submitError: '審査に送信する時にエラーが発生しました。もう一度お試しください。',
    letterCounter: '返却カウンター',
    car: '自動車',
    tram: '電車',
    cruise: 'クルーズ',
    tourDetailTemp: 'コース詳細',
    auditingProductNum: '審査待ちの商品数',
    productNum: '商品数',
    orderSum: '予約数',
    payBySupplierNum: '取引額',
    balanceNum: '残高',
    productOrderNum: '商品数',
    distritorNum: 'AGT数',
    supplierNum: '施設数',
    urgentNum: '緊急予約',
    confirmNum: '確認済み予約',
    unpassNum: '再度審査必要な商品',
    beConfirmNum: '確認待ち予約',
    cancelingNum: '取消待ち予約',
    unPaymentNum: '未支払い予約',
    cancelingOrder: 'キャンセル中予約',
    becancelOrder: 'キャンセル済み予約',
    auditingProduct: '審査待ち商品',
    supplierAuditing: '審査待ち施設',
    distributorAuditing: '審査待ちAGT',
    notice: '通知',
    releaseNotice: '通知発信',
    haveNotNotice: '新しい通知はありません！',
    unRead: '未読',
    readed: '既読',
    unReadNotice: '未読通知',
    noticeDetail: '通知詳細',
    messageStart: 'このメッセージは',
    messageMiddle: 'から有効になる。管理者は',
    messageEnd: 'からこのメッセージを発信しました。',
    country: '国',
    province: '都道府県',
    city: '市',
    area: '地域',
    year: '年',
    month: '月',
    one: '月',
    two: '火',
    three: '水',
    four: '木',
    five: '金',
    six: '土',
    seven: '日',
    buyPrice: '卸価格',
    selectSupplier: 'サプライヤーを選択する',
    updloadFiles: 'データアップロード：',
    pleaseChange: '選択してください',
    auditMessageEnter: '予約情報入力',
    auditMessageEnter1: '予約情報入力',
    enterAmount: '数',
    pleaseEnterProductAmount: '購入数を入力してください',
    endSlary: '清算金額(JPY)',
    endTotalAmount: '金額合計',
    ridePlace: '乗車位置',
    getOnTheTrain: '乗車地点',
    onTrainTime: '乗車時間',
    choseUpPlace: '乗車地点を選択してください。',
    choseDownPlace: '降車地点を選択してください。',
    getDownTheTrain: '降車地点',
    downTrainTime: '降車時間',
    orderMessageByMe: '予約内容',
    confirmEmail: '予約内容送信用E-mail',
    aboutTipMessage: '予約ご本人様、または貴社担当者様のメールアドレスをご記入ください。決済後予約内容とともに電子バウチャーが送信されます。',
    aboutOrderLanguageType: '確認メール用言語選択',
    aboutChangeData: '日付選択',
    travler: 'お客様',
    mainTravler: '代表者',
    travlerName: 'お客様名前',
    travlerPhone: 'お客様携帯電話',
    customerEmail: 'メールアドレス',
    customerWechat: 'Wechat',
    customerPassport: 'パスポート',
    customerSex: '性別',
    orderByMessage: 'その他',
    orderExplain: '予約説明',
    productUseData: '利用流れ',
    canBeTaken: '引換可能カウンター',
    mustBeComplate: 'パスポートチェックインが必要な施設様（ご予約の場合）では必ずフルネームをご入力ください',
    productCanBeReciveTo: 'この製品はお客様にSMSかメールを送付しますから、携帯番号又はメールアドレスをせめて一つ記入してください(中国大陸の携帯でない場合、メールアドレスをお願いします)。',
    submitOrder: '予約送信',
    nowPages: '現在の商品',
    travlerEmail: 'お客様のメールアドレス',
    travlerWebchat: 'お客様のWechat',
    travlerPassport: 'パスポート',
    travlerAddress: '宅便アドレス',
    travlerPostCode: '郵便番号',
    travlerCreditType: '証明書',
    travlerCreditNo: '証明書番号',
    travlerSex: 'お客様の性別',
    mustToWrite: '必須',
    notMustToWrite: '非必須',
    orderStatus0: '予約作成',
    orderStatus1: '予約送信',
    orderStatus2: '予約取消（AGT）',
    orderStatus3: '注文取消（サプライヤー）',
    orderStatus4: '予約確認',
    orderStatus5: '利用済み予約',
    orderStatus6: '未支払いで取消された予約',
    orderStatus7: '予約できない',
    orderStatus8: '予約の取消を確認',
    orderStatus9: '予約の取消を断る',
    orderStatus10: '自動で予約を確認',
    orderStatus11: '自動で予約を完成',
    orderStatus12: '自動で予約を取消',
    orderStatus13: 'タイムアウトで注文が自動的に取消します',
    orderStatus14: '返金申請',
    orderStatus15: '返金確認',
    orderStatus16: '返金拒む',
    orderStatus17: '予約認証済み',
    orderStatus18: '予約確認済み',
    orderStatus19: '管理者特殊キャンセル',
    orderStatus20: 'パス券片方キャンセル',
    orderStatus21: '自動で有効期切れ予約を処理',
    orderStatus22: '接続先APIキャンセル',
    orderStatus23: 'システム片方キャンセル',
    notPaymentTag: '未支払いで取消',
    travelsSelectData: 'お客様が指定した日付前',
    jtrOrderRefund0: '利用日付前',
    jtrOrderRefund1: '利用日付後',
    jtrOrderRefund2: '日返金可能',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '日返金可能',
    day: '日',
    ticketPrice: '',
    refundPayment: '返金手数料率 :',
    cancelCannot: '取消の理由',
    refundCannot: '返金理由',
    cancelOrRefund: '拒否の理由',
    cancelReason: '取り消し理由',
    admin: '管理者',
    clerk: 'スタッフ',
    refuseCannot: '拒否の理由',
    updateTime: '更新時間',
    counterDetails: 'カウンター詳細',
    applyDate: '申請日時',
    pleaseIntoCancelReason: '拒否の理由を入力してください',
    pleaseIntoCancelCannot: '取消の理由を入力してください',
    pleaseIntoInfo: '文字を入力してください',
    applyType: {
      applyType0: 'AGT',
      applyType1: '施設',
      applyType2: '管理者',
      applyType3: 'スタッフ',
      applyType4: '其の他'
    },
    adminAccount: {
      createUser: '権限追加',
      roleName: '権限名',
      createRoleName: '権限名',
      account: '所属ID',
      applyType: '適用する種類',
      isEnable: '有効にするか',
      enable: '有効化',
      disable: '無効化',
      roleDistribution: '権限',
      roleManager: '権限追加',
      authMenu: '権限一覧',
      checkAll: '全て選択'
    }
  },
  viewMessage: {
    message1: '保存しますか？',
    message2: '観光地名を入力してください。',
    hotCity_message2: '目的地名を入力してください。',
    hotCity_message19: '1〜200文字以内で入力してください。',
    hotCity_remark_placeholder: '備考を入力してください。',
    banner_save_success: 'Banner saved successfully!',
    banner_save_error: 'Failed to save banner!',
    message3: '観光地の住所を入力してください。',
    message4: 'おすすめ',
    message5: '保存しますか？',
    message6: '保存しますか？',
    message7: '保存しますか？',
    message8: '観光地のロケーションを選択してください。',
    message9: '3から50文字以内。',
    sysError: 'システムエラー',
    revokeMessage: 'この操作により審査が撤回されますが、継続しますか？',
    revokeSuccess: '審査申請キャンセル済み',
    revokeHavePassed: 'この商品は既に審査に通過されたため申請キャンセルできません',
    revokeHaveNotPassed: 'この商品は審査に通過できなかったため、撤回操作はできません。新規申請を提出してください！',
    revokeOperationCanceled: '審査の撤回が取消されました！',
    offLineMessage: 'この操作により商品をオフラインされますが、継続しますか？',
    offLineSuccess: '販売停止できました',
    offLineOperationCanceled: '販売停止操作がキャンセルしました。',
    onLineSuccess: '販売開始できました',
    onLineMessage: 'この操作により商品をオンラインされますが、継続しますか？',
    deleteMessage: 'この操作により当該商品が完全に削除されますが、継続しますか？',
    deleteMessageOrder: 'この操作により当該注文が完全に削除されますが、継続しますか？',
    deleteSuccess: '削除できました！',
    deleteOperationCanceled: '削除が取消されました！',
    thisRangeNotEmpty: '当該指定範囲内では販売店が空白にしてはいけません！',
    thisPriceRangeNotEmpty: '販売店のAGT仕入価格授権は空白にしてはいけません！',
    thisPriceRangeNotNum: '数字を入力してください！',
    editSuccess: '編集ができました！',
    pleaseDeletePackageProduct: '先にパッケージ商品を削除してください。又はパッケージ商品の中から当該商品を削除してください！',
    upToLine: 'この操作が完了後に、商品はオンラインされますが、継続しますか？',
    newToUse1: 'この操作が完了後に、製品のバッチ状態が終了になりますが、続けますか?',
    newToUse0: 'この操作が完了後に、製品のバッチ状態が正常になりますが、続けますか?',
    fileToDelete: 'この操作が完了後に、このファイルベースは完全に削除されますが、継続しますか？',
    useSuccess: '操作が成功した',
    useFail: '操作が取消された',
    holdSuccess: '保存できました！',
    holdError: '保存は失敗しました！',
    maxDay: '一回の設定につき、上限は十年間のデータのみ',
    submitSuccess: '送信できました！',
    submitSuccessconfirmed: '送信成功！確認まで少々お待ちください！',
    submitError: '送信に失敗しました！',
    balanceNotDone: 'ご利用のアカウントの残高が足りませんので、チャージしてから今回の注文を完成させてください。',
    balanceDone: '支払完了。',
    cancelDone: 'ご注文の取消申請は送信されました。販売店の対応をお待ち下さい。',
    cancelDone2: '取消申請及び返金が成功しました!このページをリフレッシュしてご確認ください',
    cancelDone3: '返金申請は送信しました、処理完了までをお待ちください',
    cancelError: '残高が足りないため、現在注文を取消できません。',
    cancelError1: '系统异常，请联络管理员',
    message10: '編集した内容を保存しますか？',
    lable1: 'キャンセル',
    lable2: '保存しない',
    lable3: '保存',
    message11: '3から50文字以内。',
    message12: '国籍を選択してください',
    message13: '地区を選択してください',
    message14: '3から50文字以内。',
    message15: '基本情報に記入されていない必須項目があります',
    message16: '編集を廃棄しますか？',
    message17: '観光地は利用中ですから、削除できません！',
    confirmDone: '確認できました',
    tipMessage1: 'ユーザの備考を入力してください。',
    tipMessage2: '入力の長さは255ケタを超えないように',
    tipMessage3: 'ユーザ名を入力してください。',
    tipMessage4: '入力の長さは100ケタを超えないように',
    tipMessage5: 'コミッション比率は0から100の整数しか入力できません',
    messageNotCompleteIn: '記入されていない必須項目があります',
    orderStatusHadUpdate: '注文情報が更新済み',
    orderRefundFalse: '予約返金の申請が失敗しました',
    message18: '0から500文字以内。',
    message19: '3から500文字以内。',
    message20: '当該種類は期間中に既に存在しています',
    cleckOrder: '予約を認証しますか',
    cleckOrderCanceled: '認証をキャンセルしました',
    cleckSucc: '認証成功'
  },
  counterMessage: {
    counterName: 'カウンター名',
    counterAddress: 'カウンター住所',
    counterTelephone: 'カウンターの電話番号',
    busineTime: '営業時間',
    counterPic: 'カウンターの写真',
    lable1: 'キャンセル',
    lable2: '保存しない',
    lable3: '保存',
    message1: 'カウンター名を入力してください',
    message2: 'この操作により当該カウンターの内容はすべて削除されますが、継続しますか？',
    message3: '削除できました',
    message4: '利用中のため、削除できません',
    message5: 'カウンター写真をアップロード',
    message6: '編集内容を保存しますか？',
    message7: 'カウンター名前を入力してください',
    message8: 'カウンター住所を入力してください',
    message9: 'カウンターの電話番号を入力してください',
    message10: '正確なカウンターの電話番号をを入力してください',
    message11: '長さは6から500ケタまでにしてください',
    message12: 'カウンターの接待時間を入力してください',
    message13: '保存できませんでした',
    message14: '保存できました',
    message15: '編集内容を廃棄しますか？',
    message16: '長さは1から500ケタまでにしてください'
  },
  liaisonMessage: {
    liaisonName: '名前',
    liaisonTelephone: '連絡先',
    receptionTime: '対応時間',
    message1: '連絡先の名前を入力してください',
    message2: '連絡先の電話番号を入力してください',
    message3: '連絡先の接待時間を入力してください',
    message4: '削除しますか？',
    message5: '削除できました',
    message6: '利用中のため、削除できません',
    message7: '編集内容を保存しますか？',
    message8: 'キャンセル',
    message9: '保存しない',
    message10: '保存',
    message11: '保存できませんでした',
    message12: '編集内容を廃棄します？',
    message13: '保存できませんでした',
    message14: '保存できました'
  },
  registerMessage: {
    directorWechatComment: '弊社からの案内等をスピーディーにこなうため、こちらの利用を推薦しています。詳しくは別途配布しているマニュアルをご確認ください。',
    supplierRegister: '出店登録',
    distributorRegister: 'AGT登録',
    accountInfo: 'アカウント情報',
    companyInfo: '会社情報',
    mainBusiness: '主の業務内容（選択した業務内容によって、適合な商品をお勧めします）',
    mainBusiness1: '主の業務内容',
    saleType: '販売ルート',
    trafficCardTicket: '交通券',
    carFree: 'レンタカー/送迎バス',
    admissionToThePark: '電子チケット',
    foodAndBeverage: 'レストラン',
    oneDayTour: 'DAYツアー',
    daysTour: 'ツアー',
    characteristicExperience: '体験',
    hotel: 'ホテル',
    physicalShop: '実店舗',
    fzShop: 'Fliggy',
    mfwShop: 'マーフォンウォー',
    tbShop: '淘宝（タオバオ）',
    xcShop: 'CTRIP',
    tcShop: 'Tongcheng',
    qneShop: 'Qunar.com',
    tnShop: 'Tuniu',
    cupang: 'cupang',
    gmarket: 'gmarket',
    entry: '入力してください',
    directorInfo: '業務責任者情報',
    account: 'ログインID',
    password: 'パスワード',
    passwordConfirm: 'パスワード(再入力)',
    address: '所在地',
    companyName: '会社名',
    logo: '会社ロゴ',
    legalRepresentative: '法定代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyEmail: '会社E-mail',
    companyWebsite: '公式サイト/店舗リンク',
    bankCardNumber: '銀行口座',
    qualification: '登録認定',
    directorName: '名前',
    directorTelephone: '携帯番号',
    directorPosition: '役職',
    directorWechat: 'WechatID',
    directorCode: '招待コード',
    phDirectorCode: '招待コードを入力してください',
    directorCodeTip: '招待コードを入力すると、優先審査などの特典を受けられます',
    directorEmail: 'メールアドレス',
    directorCard: '名刺',
    phAccount: 'ログインIDを入力してください',
    phPassword: 'パスワードを入力してください',
    phPasswordConfirm: 'もう一度パスワードを入力してください',
    phCompanyName: '会社の正式な登録名を記入してください',
    phLogo: '会社のLogoをアップロード',
    phLegalRepresentative: '会社の法定代表者を入力してください',
    phCompanyAddress: '会社の住所を入力してください',
    phCompanyTelephone: '会社の電話番号を入力してください',
    phCompanyEmail: '会社のEメールを入力してください',
    phCompanyWebsite: '会社の公式サイト（又はその他プラットフォームにある店舗のリンク）を入力してください',
    phBankCardNumber: '会社の口座情報を入力してください',
    phQualification: '会社の登録書類（登記簿謄本など）をアップデート',
    phDirectorName: '業務責任者の名前を入力してください',
    phDirectorTelephone: '業務責任者の携帯番号を入力してください',
    phDirectorPosition: '業務責任者の職位を入力してください',
    phDirectorWechat: '業務責任者のWechat番号を入力してください',
    phDirectorEmail: '業務責任者のメールアドレスを入力してください',
    phDirectorCard: '業務担当者の名刺画像をアップロードしてください',
    submitResigt: '申请',
    message1: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message2: 'ご記入の口座情報が間違えないように確認してください！',
    message3: 'パスワードを入力してください',
    message4: '正確なパスワードを入力してください',
    message5: '制限文字数は6文字から16文字まで',
    message6: 'もう一度パスワードを入力してください',
    message7: '二回入力されたパスワードが一致しません！',
    message8: '正確なパスワードを入力してください',
    message9: '国籍を選択してください',
    message10: '正式な登録会社名を入力してください',
    message11: '長さは6から200ケタまでにしてください',
    message12: '会社のLogoをアップロードしてください',
    message13: '会社の法定代表者を入力してください',
    message14: '長さは2から200ケタまでにしてください',
    message15: '詳細な会社の住所を入力してください',
    message16: '長さは10から200ケタまでにしてください',
    message17: '会社の電話番号を入力してください',
    message18: '正確な電話番号を入力してください',
    message19: '制限文字数は4文字から20文字まで',
    message20: '会社のEメールを入力してください',
    message21: '正確な会社のE－mailを入力してください',
    message22: '長さは7から50ケタまでにしてください',
    message23: '会社の資格・認定をアップロードしてください',
    message24: '制限文字数は4文字から300文字まで',
    message25: '会社の銀行口座を入力してください',
    message26: '正確な会社の銀行口座を入力してください',
    message27: '制限文字数は10文字から100文字まで',
    message28: '会社の資格・認定をアップロードしてください',
    message29: '業務責任者の名前を入力してください',
    message30: '制限文字数は2文字から50文字まで',
    message31: '携帯番号を入力してください',
    message32: '正しい携帯番号を入力してください',
    message33: '長さは6から20ケタまでにしてください',
    message34: '役職を入力してください',
    message35: '制限文字数は2文字から50文字まで',
    message36: 'Wechat番号を入力してください',
    message37: '長さは6から50ケタまでにしてください',
    message38: '業務担当者の名刺画像をアップロードしてください',
    message39: '登録に送信しますか？',
    message40: '登録できました',
    message41: '登録できませんでした',
    message42: 'IDを入力してください',
    message43: '制限文字数は6文字から30文字まで',
    message44: 'このIDは既に存在します',
    message45: 'メールアドレスを入力してください',
    message46: '長さは5から50ケタまでにしてください',
    message47: '正しいメールアドレスを入力してください',
    message48: 'このメールアドレスは既に登録されました',
    message49: '登録を廃棄しますか？',
    message50: '主の業務内容を選択してください、複数選択可能',
    message51: '販売ルートを選択してください、複数選択可能',
    message52: 'その他を選択された場合、内容を入力してください',
    message53: '制限文字数20文字まで'
  },
  menu: {
    sysHome: 'トップページ',
    product: '商品管理',
    productList: '商品管理',
    releaseProducts: '新規作成',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '商品販売管理',
    importThirdSystemProduct: '商品導入管理',
    conciseEticket: '電子チケットを発売します',
    conciseTicket: 'チケットを発売します',
    conciseTravel: '旅行商品を発売します',
    conciseWifi: 'WiFi商品を発売します',
    conciseSIM: 'SIM商品を発売します',
    conciseDining: '食事商品を発売します',
    conciseTransport: '交通商品を発売します',
    conciseDiscount: 'パッケージ商品を発売します',
    conciseSetMeal: '新規作成（セット商品）',
    conciseExperience: '新規作成（入場/体験）',
    productAuditing: '商品審査',
    addBusFlag: '夜行バス商品新規作成',
    orderManagement: '予約管理',
    orderManagementC: 'C端子管理',
    operatorOrderManagement: '予約管理',
    operatorOrderMagnToC: 'ToC予約管理',
    operatorOrderManagement_chargeback: '予約取り消し権限',
    reserve: '商品予約',
    distriOrderMagn: '予約管理',
    disTocOrderManagement: 'ToC予約管理',
    bulkPurchaseList: '一括購入管理',
    tocDistributorManageProduct: 'ToC商品販売管理',
    distriOrderMagnToC: 'ToC予約管理',
    applyDistribution: 'ToC審査',
    revenueManagement: 'ToCエージェント管理',
    revenueDetail: 'ToC収益管理',
    applyCash: 'ToC現金引き出し管理',
    operatApplyCash: 'ToC現金引き出し管理',
    coupon: 'ToCクーポン管理',
    pinTicketMagn: '認証出庫管理',
    ticket: '実物券在庫管理',
    ticketDepot: 'チケット在庫管理',
    warehouse: '倉庫管理',
    userDepot: 'ユーザ倉庫管理',
    pinTicket: '認証出庫',
    pdfTicket: '電子チケット在庫管理',
    pdfFiles: 'PDFファイルベース管理',
    shopManage: 'ユーザー管理',
    distributor: 'AGT管理',
    supplier: '施設管理',
    scenicSpot: '観光地管理',
    scenicSpotList: '観光地管理',
    finance: '精算管理',
    financeStatement: '明細',
    financeDetail: '財務明細書の詳細情報',
    ActuarialManagement: '精算管理',
    withdrawals: 'チャージ/現金引出管理',
    operatorWithdrawal: 'チャージ/現金引出管理',
    trades: '取引明細',
    record: 'チャージ/現金引出履歴',
    withdrawal: 'チャージ/現金引出',
    recharge: 'チャージ/現金引出',
    sys: 'システム管理',
    merchantInfo: '店舗情報',
    clerk: 'スタッフ管理',
    adminAccount: '権限管理',
    secondaryAgent: '二次代理店管理',
    operator: '管理者管理',
    exportRules: 'エクスポート規則管理',
    noticeManager: '通知管理',
    liaisons: '連絡先管理',
    counter: 'カウンター管理',
    pwdSet: 'パスワード設定',
    payType: '支払い方法設定',
    newOrderEmail: '新規注文メール通知設定',
    ticketDepot_ticketDepotManager: 'チケット在庫管理者',
    ticketDepot_stockManager: '在庫管理者',
    pdfFiles_stockManager: '在庫管理者',
    operatorWithdrawal_operationAuth: '財務操作権限',
    operatorWithdrawal_auditAuth: '財務審査権限',
    auditFlag: 'レビューは要らない',
    loginNotice: 'システム機能アップグレード通知（20170621）',
    recover: '初期化',
    clear: 'クリア',
    pageSetting: 'ホームページ写真設置',
    productLogList: '商品变更記録',
    popularCities: '人気目的地管理',
    banner: 'バナー管理',
    recommendedAttractions: 'ホームページ推奨管理'
  },
  login: {
    userLogin: 'ユーザログイン',
    rememberLoginStatus: '次回から入力を省略',
    forgetPassword: 'パスワードを忘れた方',
    loginIn: 'ログイン',
    register: '新規登録',
    copyRight: 'Copyright © 2019 東瀛假日',
    recordInformation: '蜀ICP備18029410号-2',
    recordInformation2: '特定商取引法',
    message1: 'ユーザ名を入力してください',
    message2: 'パスワードを入力してください',
    message3: '正しいパスワードを入力してください'
  },
  selectMerchantType: {
    imSupplier: '施設：商品登録',
    imDistributor: '旅行会社：商品購入',
    selectType: '登録種類を選択してください'
  },
  notice: {
    noticeModify: '通知を編集',
    noticeAdd: '通知を追加',
    noticeTitle: '通知のタイトル：',
    noticeContent: '通知の内容',
    noticeTitlePlaceholder: '通知のタイトルを入力してください',
    validDate: '有効期限：',
    DateSelectRange: '日付の範囲を選択',
    publicationScope: '知らせる範囲：',
    all: '全般',
    distributor: 'AGT',
    supplier: '施設',
    pulicationConfirm: '確認',
    tip: 'メッセージ',
    saveOrNot: '保存しますか？',
    notSave: '保存しない',
    save: '保存',
    message1: '3から150文字以内。',
    message2: '有効期限を選択してください',
    message3: '範囲を選択してください',
    message4: '編集を廃棄しますか？',
    message5: '基本情報に記入されていない必須項目があります',
    message6: '保存できました',
    message7: '保存できませんでした',
    message8: '削除できませんでした！',
    message9: '削除できました！',
    message10: 'この操作により、当該ファイルは完全に削除されますが、継続しますか？',
    message11: '選択される店舗は空白にしてはいけません！',
    noticeManage: '通知管理',
    noticePublication: '通知を追加',
    noticeTitle1: '通知のタイトル',
    search: '検索',
    index: '番号',
    title: 'タイトル',
    publicationScope1: '通知範囲',
    validDate1: '有効期限'
  },
  exportRules: {
    exportRuleTitle: 'エクスポート規則の管理',
    newExportRule: 'エクスポート規則を追加',
    editExportRule: 'エクスポート規則を編集',
    lableBusinessType: 'ユーザー種類',
    pageType: 'ページ種類',
    exportRuleName: 'エクスポート規則の説明',
    exportRuleRemark: 'エクスポート規則の備考',
    search: '検索',
    ruleName: '規則の名称',
    ruleRemark: '規則の備考',
    modify: '編集',
    delete: '削除',
    lable1: '全部',
    lable2: 'AGT',
    lable3: '施設',
    lable4: '商品一覧',
    lable5: '予約一覧',
    lable6: '経営者',
    lable7: '未知',
    lable8: 'エクスポート項目設定',
    lable9: '削除',
    lable10: '追加',
    lable11: 'すべての項目',
    lable12: 'エクスポート項目',
    lable13: '認証一覧',
    message1: '本当に削除しますか？',
    message2: '削除できました',
    message3: '基本規則なので、削除できません',
    message4: '規則が利用中なので、削除できません',
    message5: 'エクスポート規則の名称を入力してください',
    message6: 'エクスポート規則の備考を入力してください',
    message7: '店舗種類を選択してください',
    message8: 'ページ種類を選択してください',
    message9: '長さは3から100ケタにしてください',
    message10: '長さは3から500ケタにしてください',
    message11: '本当にリセットしますか？',
    message12: '保存できました',
    message13: '本当に編集を廃棄しますか？',
    button1: '保存',
    button2: '新規作成',
    button3: 'リセット'
  },
  clerk: {
    clerkTitle: 'スタッフ管理',
    addClerk: 'スタッフ追加',
    editClerk: '事務員編集',
    account: 'ID',
    name: '名前',
    telphone: '電話番号',
    emailAddress: 'メールアドレス',
    clerkAccount: 'スタッフのアカウント',
    clerkName: 'スタッフの名前',
    clerkPwd: 'スタッフのパスワード',
    confirmPwd: 'パスワード確認',
    clerkTel: 'スタッフの携帯番号',
    message1: 'スタッフのアカウント/名前',
    message2: '権限を選択してください',
    message3: '本当に削除しますか？',
    message4: '削除できました',
    message5: '設定完了',
    message6: 'スタッフのアカウントを入力してください',
    message7: 'アルファベット、数字、アンダーバー又はデリミターのみ入力可能、最初の文字はアルファベットで入力してください',
    message8: 'スタッフの名前を入力してください',
    message9: 'スタッフの名前は空白にしてはいけません',
    message10: 'スタッフのパスワードを入力してください',
    message11: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message12: '上記入力された内容と一致しないといけません',
    message13: 'スタッフの携帯番号を入力してください',
    message14: 'スタッフのメールアドレスを入力してください',
    message15: 'メールでシステムメッセージを受信できます',
    message16: '長さは1から50ケタまでにしてください',
    message17: '正確なパスワードを入力してください',
    message18: '制限文字数は6文字から16文字まで',
    message19: '正確なパスワードを入力してください',
    message20: '保存しますか？',
    message21: '保存できました',
    message22: 'IDを入力してください',
    message23: '制限文字数は6文字から30文字まで',
    message24: '正確なアカウントを入力してください',
    message25: 'ユーザ名は既に存在しています',
    message26: 'もう一度パスワードを入力してください',
    message27: '二回入力されたパスワードは一致しません！',
    message28: '長さは5から50ケタまでにしてください',
    message29: '正しいメールアドレスを入力してください',
    message30: 'このメールアドレスは既に登録されました',
    message31: '長さは6から20ケタまでにしてください',
    message32: '正しい携帯番号を入力してください',
    message33: '編集を廃棄しますか？',
    lable1: '権限',
    lable2: '削除',
    lable3: '追加',
    lable4: '権限リスト',
    lable5: '追加済みの権限'
  },
  merchant: {
    merchantInfo: '店舗情報',
    distributorManage: '販売店管理',
    supplierManege: 'サプライヤー管理',
    all: '全部',
    waitAudit: '審査待ち',
    auditPass: '審査通過',
    auditNG: '審査失敗',
    auditNG2: '審査失敗',
    auditNGReason: '審査失敗の理由を編集',
    searchContent: '店舗名/ID',
    businessName: 'AGT名',
    createDate: '申請時間',
    auditStatus: '状態',
    auditUserName: '審査係',
    lableTodo: '処理',
    lableWatch: '詳細',
    lableAuth: '権限',
    lableExpSet: 'エクスポート設定',
    accountInfo: 'アカウント情報',
    loginAccount: 'ログイン',
    companyName: '会社名 ',
    companyLogo: '会社ロゴ',
    legalRepresentative: '代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyWebsite: '公式サイト/店舗リンク',
    companyEmail: '会社E-mail',
    bankCardNumber: '銀行口座',
    qualificationPath: '会社登録書類',
    location: '所在地',
    baseInfo: '会社情報',
    directorInfo: '業務責任者情報',
    directorName: '名前',
    directorPosition: '役職',
    directorEmail: 'メールアドレス',
    directorTelephone: '携帯番号',
    directorWechat: 'WechatID',
    directorCardPath: '名刺',
    setAuthAuditPass: '権限を設定し、審査に通過',
    selectAuth: '権限を選択してください',
    message1: '権限を選択してください',
    message2: 'エクスポート設定',
    message3: 'エクスポートページの種類',
    message4: '商品のエクスポート項目の設定',
    message5: '注文のエクスポート項目の設定',
    message6: 'エクスポート規則',
    message7: 'エクスポート規則の名称を選択してください',
    message8: 'エクスポートページの種類を選択してください',
    message9: 'エクスポート規則を選択してください',
    message10: '設定完了',
    message11: '(店舗がシステム内にある唯一のコードであり、ユーザの身分を識別に使われます)',
    message12: '販売状況のまとめ',
    message13: '総予約数',
    message14: '総注文金額',
    message15: '総発券数',
    message16: 'Depo管理',
    message17: '残高',
    message18: 'アカウントの取引日誌を閲覧',
    message19: 'チャージ/現金引出履歴',
    message20: '操作できました',
    message21: '操作に失敗しました',
    message22: '審査を放棄しますか？',
    message23: '与信設定',
    message24: '認証のエクスポート項目の設定',
    lable1: '削除',
    lable2: '追加',
    lable3: '権限リスト',
    lable4: '追加済みの権限',
    yayaPaySet: '消去アカウントを設定する',
    easyGoUser: 'サプライヤーのアカウント',
    yayaPayUser: '消去アカウント',
    pleaseEnterYayaPayUser: '消去アカウントを入力してください',
    pleaseEnterLessTen: 'アカウント数は十まで！',
    lengthMustLess100: 'アカウントの長さは1から100まで！',
    yayaAccountHadExists: '同じアカウントが登録したので、追加できない',
    yayaAccountExists: '同じアカウントが登録したので、新しいアカウントを入力してください',
    enableSwitch: '実行設定',
    lineOfCredit: '与信金額',
    creditDate: '信書の期日'
  },
  merchantInfo: {
    merchantInfo: '店舗情報',
    merchantInfoEdit: '店舗情報を編集',
    auditNG: '審査失敗',
    accountInfo: 'アカウント情報',
    auditStatus: '審査状態',
    loginAccount: 'ログイン',
    location: '所在地',
    baseInfo: '会社情報',
    companyName: '会社名',
    companyLogo: '会社ロゴ',
    legalRepresentative: '法定代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyWebsite: '公式サイト/店舗リンク',
    companyEmail: '会社E-mail',
    bankCardNumber: '銀行口座',
    qualificationPath: '資格証明書',
    supplierSummary: '販売情報のまとめ',
    orderTotal: '総予約数',
    orderTotalPay: '総注文金額',
    ticketTotal: '総発券数',
    accountBalanceInfo: '残高状況',
    accountBalance: '残高',
    seeBusinessLog: 'アカウントの取引日誌を閲覧',
    seeRechargeLog0: 'チャージ/現金日誌を閲覧',
    seeRechargeLog1: '現金日誌を閲覧',
    directorInfo: '責任者の情報',
    directorName: '名前',
    directorPosition: '役職',
    directorEmail: 'メールアドレス',
    directorTelephone: '携帯番号',
    directorWechat: 'WechatID',
    directorCardPath: '名刺',
    submitAudit: '審査提出',
    submitEdit: '訂正を送信',
    notSave: '保存しない',
    save: '保存',
    message1: '(店舗がシステム内にある唯一のコードであり、ユーザの身分を識別に使われます)',
    message2: 'ご記入の口座情報が間違えないように確認してください！',
    message3: '編集を保存しますか？',
    message4: '国を選択してください',
    message5: '正式な会社登録名を入力してください',
    message6: '長さは6から200ケタまでにしてください',
    message7: '会社のLogoをアップロードしてください',
    message8: '会社の法定代表者を入力してください',
    message9: '長さを2から200ケタまでにしてください',
    message10: '詳細な会社の住所を入力してください',
    message11: '長さは10から200ケタまでにしてください',
    message12: '会社の電話番号を入力してください',
    message13: '正しい電話番号を入力してください',
    message14: '長さは6から20ケタまでにしてください',
    message15: '会社のEメールを入力してください',
    message16: '正しいメールアドレスを入力してください',
    message17: '制限文字数は7文字から50文字まで',
    message18: '会社の公式サイトをを入力してください',
    message19: '制限文字数は4文字から50文字まで',
    message20: '会社の銀行口座番号を入力してください',
    message21: '正しい口座番号を入力してください',
    message22: '制限文字数は10文字から100文字まで',
    message23: '会社の資格・認定をアップロードしてください',
    message24: '業務責任者の名前を入力してください',
    message25: '制限文字数は2文字から50文字まで',
    message26: '携帯番号を入力してください',
    message27: '正しい携帯番号を入力してください',
    message28: '役職を入力してください',
    message29: 'Wechat番号を入力してください',
    message30: '制限文字数は6文字から50文字まで',
    message31: '業務担当者の名刺画像をアップロードしてください',
    message32: '内容を変更しますか?',
    message33: '変更できました',
    message34: '変更できませんでした',
    message35: 'メールアドレスを入力してください',
    message36: '制限文字数は5文字から50文字まで',
    message37: '正しいメールアドレスを入力してください',
    message38: 'このメールアドレスは既に登録されました'
  },
  secondaryAgent: {
    secondaryAgentTitle: 'セカンダリーエージェントです',
    message1: '名前を入力してください',
    search: '検索',
    name: '名前',
    time: '登録日時',
    remark: '備考',
    label: '解綁',
    addCode: '招待コードを生成',
    copySuccess: 'コピー成功',
    copyError: 'コピー失敗',
    operator: '備考を編集',
    remarkTip: '備考を入力してください',
    message2: '編集成功しました',
    message3: '編集失敗しました',
    message4: '解綁成功しました',
    message5: '解綁失敗しました'
  },
  errorMsg: {
    user: {
      noAuth: 'ユーザ様の権限が足りません。スステム管理者に連絡してください',
      systemMsg: 'システムエラー',
      noUserOrPassword: 'IDまたはパスワードが正しくありません',
      setUsernameOrPassword: 'IDとパスワードを入力してください'
    }
  },
  operator: {
    jtrOrderReimburse: 'システム片方キャンセル',
    operatorManege: '管理者管理',
    addOperator: '管理者追加',
    updateOperator: '管理者変更',
    updatePwd: 'パスワード変更',
    updateInfo: '編集',
    auth: '権限',
    searchText: '管理者のID/名前',
    account: 'ID',
    name: '名前',
    opearate: '操作',
    opeAccount: '管理ユーザー',
    opeName: '管理者の名前',
    opePwd: 'パスワード',
    opeNewPwd: '管理者の新しいパスワード',
    checkPwd: 'パスワード確認',
    lable1: '削除',
    lable2: '追加',
    lable3: '権限リスト',
    lable4: '追加済みの権限',
    message1: '権限を選択してください',
    message2: '本当に削除しますか？',
    message3: '削除できました',
    message4: '設定完了',
    message5: '管理者ユーザーを入力してください',
    message6: 'アカウントはアルファベット、数字、アンダーバー又はデリミターのみにより構成され、しかも先頭文字はアルファベットにしないといけません',
    message7: '管理者の名前を入力してください',
    message8: '管理者の名前は空白にしてはいけません',
    message9: 'パスワードを入力してください',
    message10: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message11: '上記入力された内容と一致しないといけません',
    message12: '制限文字数は1文字から50文字まで',
    message13: '制限文字数は6文字から16文字まで',
    message14: '正確なパスワードを入力してください',
    message15: '保存しますか？',
    message16: '保存できました',
    message17: 'IDを入力してください',
    message18: '制限文字数は6文字から30文字まで',
    message19: '正しいIDを入力してください',
    message20: 'このIDは既に存在します',
    message21: 'もう一度パスワードを入力してください',
    message22: '二回入力されたパスワードは一致しません！',
    message23: '編集を廃棄しますか？'
  },
  product: {
    rule_0_500: '制限文字数は0文字から500文字まで',
    rule_0_5000: '制限文字数は0文字から5000文字まで',
    rule_1_200: '制限文字数は1文字から200文字まで',
    rule_1_2000: '制限文字数は1文字から2000文字まで',
    rule_1_500: '制限文字数は1文字から500文字まで',
    rule_0_200: '制限文字数は0文字から200文字まで',
    rule_0_2000: '制限文字数は0文字から2000文字まで',
    rule_0_50: '制限文字数は0文字から50文字まで',
    rule_0_1_500: '制限文字数は0文字から500文字まで',
    rule_1_50: '制限文字数は1文字から50文字まで',
    rule_0_20: '制限文字数は0文字から20文字まで',
    rule_n1_2: '制限文字数は1文字から2文字まで',
    rule_n1_4: '制限文字数は1文字から4文字まで',
    rule_n1_6: '制限文字数は1文字から6文字まで',
    rule_n0_2: '制限文字数は0文字から2文字まで',
    rule_n0_5: '制限文字数は0文字から5文字まで',
    rule_n0_6: '制限文字数は0文字から6文字まで',
    rule_mail: 'メールの内容を入力してください',
    integer_1: '整数を入力してください',
    integer_2: '正の整数を入力してくだい',
    selDate: '日付を選択',
    back: '戻る',
    ticketType_1: '連携されたeチケット保有在庫から自動発行',
    ticketType_3: '各予約でバウチャーを手動アップロード',
    ticketType_4: 'EasyGoバウチャーをシステムで自動発行',
    choose_sys: 'システムを選択：',
    chooseDepot: '倉庫を選択',
    baseInfo: '基本情報',
    content: '商品の内容',
    priceSet: '価格設定',
    reserveSet: '予約設定',
    saveDraft: '下書きに保存',
    preview: 'プレビュー',
    submitCheck: '商品アップ申請',
    submitAuditAndPass: '確認',
    isExitProduct: '編集した内容を破棄してもよろしいですか',
    isSaveDraft: '下書きを保存しますか？',
    noSave: '保存しない',
    save: '保存',
    add: '追加',
    edit: '編集',
    product_0: '商品 (電子チケット)',
    product_1: '商品 (切符)',
    product_2: '商品 (体験)',
    product_3: '商品 (日帰り/数泊)',
    product_4: '商品 (WIFI)',
    product_5: '商品 (SIMカード)',
    product_6: '商品 (レストラン)',
    product_7: '商品 (交通)',
    product_8: '商品 (セット)',
    doNotSave: '内容がかわっていないため、保存する必要がありません',
    reqMsg_1: '審査に送信できました',
    reqMsg_2: '保存できました',
    reqMsg_3: '審査に送信できませんでした！',
    reqMsg_4: '保存できませんした！',
    reqMsg_5: '審査に送信する際にエラーが発生しました。もう一度お試しください。',
    reqMsg_6: '保存できませんでした。もう一度お試しください。',
    reqMsg_7: '当セットには子商品が追加されていません！',
    reqMsg_8: 'おめでとうございます，審査通過しました',
    reqMsg_9: '残念ですが，審査失敗しました！',
    reqMsg_10: '残念ですが，審査中にエラーが発生，もう一度お試してください！',
    reqMsg_11: '商品インポート失敗、再執行してください。',
    reqMsg_12: 'この製品番号はバインドされています！',
    reqMsg_13: 'この製品は現在在庫がなく、輸入することはできません！',
    fileDepot_no: 'ファイル倉庫を選択してください',
    baseInfo_no: '基本情報の中に、必須項目まだ記入されていません',
    content_no: '商品内容の中に、必須項目まだ記入されていません',
    reserveSet_no: '予約設定の中に、必須項目まだ記入されていません',
    explain01: '内容:地名+商品名+年齢区分+セールスポイント。例：京都着物体験　女性　大人（期間限定10％off !）',
    explain02: '商品タイトルの下にあるキーワード等',
    explain03: 'エージェントを非表示にして、サプライヤーが商品を検索するのに便利になる',
    explain04: '例：大人（*歳以上）、学生（*歳~*歳まで）、子供、幼児、シニアなど',
    productName01: 'セット名：',
    productName02: '商品名：',
    qrCodeName: '二维码名称',
    productName_placeholder: '商品名を入力してください',
    qrCodeName_placeholder: '请输入二维码名称',
    productPrice_placeholder: '商品特別価格を入力してください',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '二次確認商品が含まれているため、セット商品の予約確認方法は二次確認のみ選択できます',
    errorProductConfirmType2: '二次確認商品が含まれていないため、セット商品の予約確認方法は自動確認のみ選択できます',
    errorProductConfirmType3: '当該商品はセット商品に含まれているため、予約確認方法が変更できません。',
    orderNum_placeholder: 'ソート順を入力してください',
    productHighlights01: 'セット商品のセールスポイント：',
    productHighlights02: 'セールスポイント：',
    productHighlights_placeholder: 'セールスポイントを入力してください',
    productInsideRemark: '内部備考：',
    productInsideRemark_placeholder: '内部備考を入力してください',
    scenicSpot: '該当スポット：',
    ticketType: 'チケットタイプ：',
    ticketType_placeholder: 'チケットタイプを入力してください',
    productSaleDate: '販売期間：',
    productSaleDate_placeholder: '販売期間を選択',
    categoryLabel: 'カテゴリーラベル：',
    categoryLabel_placeholder: 'カテゴリーラベルを入力し、Enterキーで確定',
    belongCity: '所属都市：',
    belongCity_placeholder: '所属都市を選択',
    chooseDepot_rule: '倉庫を選択してください',
    productName_rule: '商品名を入力してください',
    scenicSpotArr_rule: '少なくても一つの観光地を選択してください',
    scheduleDuration: 'スケジュール：',
    scheduleDuration_placeholder: 'スケジュールを入力してください',
    imageExplain: '商品関連画像：',
    uploadBtn: 'アップロード',
    videoExplain: '商品関連動画：',
    productPackageDetail: 'メニュー編集：',
    mealTimeInterval: '利用時間帯：',
    mealTime_1: '制限なし',
    mealTime_2: '朝食',
    mealTime_3: 'ランチ',
    mealTime_4: 'アフタヌーンティー',
    mealTime_5: 'ディナー',
    mealTime_6: '夜食',
    mealNumber: '食事人数：',
    mealNumber_1: 'シングルセット',
    mealNumber_2: 'ダブルセット',
    mealNumber_3: '3~4人前',
    mealNumber_4: '5~10人前',
    mealNumber_5: '10人以上',
    mealDetail01: 'コース名：',
    mealDetail01_placeholder: '商品名を入力してください',
    mealDetail02: '内容：',
    mealDetail03: '番号',
    mealDetail04: '料理名',
    mealDetail05: '数',
    mealDetail06: '写真',
    mealDetail07: '操作',
    mealDetail07_del: '削除',
    mealDetail07_up: '上へ',
    mealDetail07_down: '下へ',
    up_msg: '既にトップ行になりました',
    down_msg: '既に最後の行になりました',
    mealDetail07_add: '一行追加',
    md_delGroup: 'メニュー削除',
    md_addGroup: 'メニュー追加',
    md_validMsg: 'セット商品詳細のデータが不完全',
    md_addMsg: '最大20行追加可能！',
    md_addMsg1: '最大10グループ追加可能！',
    useTime: '利用時間：',
    useTime_1: '制限なし',
    useTime_2: '具体的な時間帯に限定',
    editorProductDetail: '詳しい説明：',
    viewAddress: '住所：',
    viewAddress_placeholder: '住所を入力してください',
    businessTime: '営業時間：',
    businessTime_placeholder: '営業時間を入力してください',
    productPeople_placeholder: '年齢制限などを入力してください',
    exclusive: '専用車標識：',
    exclusive_1: '専用車設定無し',
    exclusive_2: '男性専用車',
    exclusive_3: '女性専用車',
    lang: '言語対応：',
    lang_1: '中国語',
    lang_2: '英語',
    lang_3: '日本語',
    lang_4: '韓国語',
    productTraffic: '交通アクセス：',
    productTraffic_placeholder: '交通アクセスを入力してください',
    networkFlow4g: '4G高速通信量：',
    networkFlow4g_placeholder: '4G高速通信量を入力しくてださい',
    networkFlow3g: '3G通信量：',
    networkFlow3g_placeholder: '3G通信量を入力しくてださい',
    networkCoverage: 'カバー範囲：',
    networkCoverage_placeholder: 'カバー範囲を入力しくてださい',
    wifiAccessories: 'アクセサリー：',
    wifiAccessories_placeholder: 'アクセサリーを入力しくてださい',
    simSize: 'SIMカードのサイズ：',
    simSize_placeholder: 'SIMカードのサイズを入力しくてださい',
    pathType: '路線タイプ：',
    pathType_1: 'シェアカー',
    pathType_2: 'レンターカー',
    pathType_3: '空港送迎',
    traffic: '交通機関：',
    traffic_1: '自動車',
    traffic_2: '電車',
    traffic_3: 'クルーズ',
    groupNumber: '催行人数：',
    groupNumber_placeholder: '催行人数を入力してください',
    shoppingType: '買い物情報：',
    shoppingType_1: '買い物が含まない',
    shoppingType_2: '買い物が含む',
    scheduleInfo: '日程詳細：',
    productCostInclude: '料金に含まれる内容：',
    productCostInclude_placeholder: '料金に含まれる内容を入力してください。',
    productCostExclusive: '料金に含まれない内容：',
    productCostExclusive_placeholder: '料金に含まれない内容を入力してください',
    productUseFlow: '利用手順：',
    productUseFlow_placeholder: '利用手順を入力して下さい',
    productSupplementPath: '使用流程补充',
    userNote: '使用説明：',
    userNote_placeholder: '使用説明を入力して下さい',
    importantNote: 'ご注意：',
    importantNote_placeholder: 'ご注意を入力して下さい',
    editorFreeItem: 'サービス項目：',
    newProductPackageDtoList_rule: '一つのセット商品の詳細を記入してください',
    scheduleInfoDtoList_rule: '少なくても一つの日程が必要',
    reserveLimitDay: '予約締切設定：',
    rld01: '利用日の',
    rld02: '日前の',
    rld03_placeholder: '時',
    rld04: '前に予約する（日本時間）',
    confirmHour: '予約確認方法：',
    confirmHour_1: '自動確認',
    confirmHour_2: '二次確認',
    ch01: '二次確認の処理時間：',
    ch02: '時間内',
    ch03: '時間内',
    maxReserveNummber: '最大受け入れ人数：',
    minReserveNummber: '最少受け入れ人数：',
    mrn_explain: '無制限の場合は「0」を記入',
    orderValid: '予約の有効期間：',
    ov01: '指定される利用日当日に有効',
    ov02: '予約日から',
    ov03: '予約日から指定日',
    ov04: '指定日から',
    ov05: '指定利用日から指定日',
    ov06: '指定日',
    ov07: '指定の利用日を利用される場合',
    orderRefund: 'キャンセル規定：',
    orderRefund_1: 'キャンセル又は変更不可',
    orderRefund_2: '予約有効期間内にキャンセル可能',
    orderRefund_tip: '1. 締切時刻は当日の23時59分59秒です。\n2. 例：旅行日が1月3日の場合、1月2日より前のキャンセルは無料、\n 1月2日および1月3日のキャンセルはキャンセル料が100％となります。設定内容は以下のとおりです。\n注文有効期限の締切時刻の0日前（当日を含む）、返金手数料：100％\n注文有効期限の締切時刻の2日前（当日を含む）、返金手数料：100％\n注文有効期限の締切時刻の3日前（当日を含む）、返金手数料：0％',
    orderRefund_3: '利用する前キャンセル可能',
    refundDescription: '説明：',
    rdi_placeholder: 'キャンセル規定の説明を入力してください',
    customerData: '予約記入設定：',
    customerData_1: 'すべてのお客様の内容が必要',
    customerData_2: '代表者1名の内容のみ必要',
    mustFillInInf: '記入必須項目：',
    mustFillInInf_1: 'お名前',
    mustFillInInf_2: '携帯番号',
    mustFillInInf_3: 'WechatID',
    mustFillInInf_4: 'パスポート番号',
    mustFillInInf_5: '性別',
    mustFillInInf_6: '利用日',
    mustFillInInf_7: '受領日',
    mustFillInInf_8: 'お名前（姓）',
    mustFillInInf_9: 'お名前（名）',
    mustFillInInf_10: '電話番号',
    mustFillInInf_11: 'メールアドレス',
    mustFillInInf_12: '性別',
    mustFillInInf_13: '年齢',
    mustFillInInf_14: '緊急連絡先（電話番号）',
    mustFillInInf_15: '券種',
    mustFillInInf_16: '同行者',
    customItem: 'その他カスタマイズの記入項目',
    ci01: ' 項目名',
    ci01_placeholder: '項目の名称',
    ci02: '必須項目設定',
    ci02_placeholder: '選択してください',
    ci02_1: '必須項目ではない',
    ci02_2: '必須項目',
    ci03: '項目説明',
    ci03_placeholder: '説明',
    ci04: '操作',
    ci04_del: '削除',
    ci05: 'カスタマイズ項目を追加',
    editorNotice: '予約注意事項：',
    orderLiaison: '注文連絡：',
    emergencyLiaison: '緊急連絡：',
    validateAuthority: '認証権限：',
    receiveCounter01: '受領カウンター：',
    receiveCounter02: 'チケット受領カウンター：',
    returnCounter: '返却カウンター：',
    reserveLimitDay_rule: '予定時間の制限を入力してください',
    reserveLimitDay_rule1: '1から99日間以内',
    reserveLimitDay_rule2: '時間を入力してください',
    orderDayNotMore: '注文日からの日数は99日間を超えてはいけません',
    trip01: '第',
    trip02: '日目',
    trip03: 'スケジュール: ',
    trip04: '新しいスケジュールを追加',
    trip05: '一日追加',
    trip06: '時間帯：',
    trip06_placeholder: '時間範囲を選択',
    trip06_phBegin: '開始時間',
    trip06_phEnd: '終了時間',
    trip07: 'どこへ：',
    trip07_placeholder: 'いつどこへ行きますか？',
    trip08: '日程内容：',
    trip08_placeholder: '例えば：第　日目はどこへ行く？どうやって行く？何か特色がある？',
    trip09: '日程写真：',
    trip09_btn: 'アップロード',
    trip10: 'スケジュールを保存',
    trip_msg1: 'スケジュールが選択されていません',
    trip_msg2: '　日，スケジュール',
    tripRange_rule: '時間帯を入力してください',
    trip_interval_rule: '終了時間と開始時間を入力してください',
    groupContentTitle_rule: '目的地を入力してください',
    groupContent_rule: 'スケジュールの内容を入力してください',
    imageList_rule: 'スケジュールの写真を設定してください',
    trip_msg3: '先に一つのスケジュールを選択し、そして保存してください！',
    trip_msg4: '保存できました',
    price01: '在庫と価格',
    price02: '時間帯-',
    price03: '時間帯を追加',
    price04: '削除',
    price05: '時間帯',
    price06: '時間帯を選択',
    price061: '時間帯がかぶるのは不可能',
    price07: '卸価格',
    price08: '卸価格を入力してください',
    price09: 'AGT仕入価格',
    price10: 'AGT仕入価格を入力してください',
    price11: '市場価格',
    price12: '市場価格を入力してください',
    price13: '在庫数',
    price14: '在庫数を入力してください',
    price15: '件',
    price16: '保存',
    price17: 'リセット',
    price18: '日付範囲は空きにしてはいけない',
    price19: '時間帯は空きにしてはいけない',
    price20: '期間設定',
    price21: '円',
    price22: 'BtoB卸価格',
    price23: 'BtoB卸価格を入力してください。',
    price24: '小売価格',
    price25: '小売価格を入力してください',
    price26: '新しい種類を追加',
    price27: '種類名',
    price28: '種類名を入力してください',
    price29: '価額種類-',
    price30: '価額種類を選択してください',
    price31: '価額種類の総在庫数をご入力ください',
    price32: '総在庫数は使用数より大きいい数値をご入力ください',
    price33: '総在庫数は0より大きい数値をご入力ください',
    price34: '指定の価額種類を入力してください：大人、子供、身体障害者（大人）、身体障害者（子供）',
    price_msg1: '先に日付を選択してください',
    price_msg2: '時間帯-',
    price_msg3: '未保存',
    price_msg4: '先に日付と時間帯を選択してくださ',
    price_msg5: '保存できました',
    price_msg6: '保存に失敗しました',
    price_msg7: '削除できました',
    price_msg8: '削除に失敗しました',
    price_msg9: '最大50項目追加可',
    price_msg10: '選択項目は空っぽにならない',
    price_msg11: '保存したら当該時間帯の既存データがすべて上書きされます。保存しますか？',
    price_msg12: '確認したら “',
    price_msg13: '”内の既存データがすべて削除されます。確認しますか？',
    price_msg14: '当該価額種類の既存データがすべて上書きされます。保存しますか。',
    price_msg15: '当該価額種類の既存データがすべて削除されます。削除しますか。',
    price_msg16: '当該価額種類は使用させています。削除できません。',
    price_msg17: '当該商品に同じ価額種類が存在しているため、保存できません。',
    refund01: '注文有効期限の締切時刻の',
    refund02: '日前（当日を含む）、返金手数料：',
    refund03: '削除',
    refund04: 'カスタマイズ追加',
    refund05: '返金手数料：',
    counter01: 'カウンターを選択',
    counter02: 'カウンター',
    counter03: 'アドレス',
    counter04: '電話番号',
    counter05: '営業時間',
    liaison01: '連絡先を選択',
    clerk01: 'スタッフを選択',
    clerk02: 'ID',
    clerk03: 'スタッフ',
    clerk04: '連絡先電話番号',
    clerk05: 'メールアドレス',
    liaison02: '連絡先',
    liaison03: '連絡方法',
    liaison04: '対応時間',
    spot01: 'スポットを選択',
    spot02: 'スポットを選択',
    spot03: 'キャンセル',
    spot04: '確認',
    takeP01: '在庫から商品を選択',
    takeP02: '少なくとも一つの商品があれば、保存又は申請ができる',
    takeP03: '順番',
    takeP04: 'タイトル',
    takeP05: '卸価格',
    takeP06: 'AGT仕入価格',
    takeP07: '市場価格',
    takeP08: '数',
    takeP09: '操作',
    takeP10: '引用データ',
    takeP11: '在庫から商品を選択',
    takeP12: '削除',
    takeP13: '価額種類',
    takeP14: '専用車標識',
    stockNumber01: '在庫数',
    stockNumber02: '利用数',
    stockNumber03: '無効',
    stockNumber04: '有効',
    priceTypeHistory01: '在庫履歴',
    priceTypeHistory02: '在庫増加',
    priceTypeHistory03: '在庫減少',
    upload01: 'jpg/png/jpeg/gifのファイルのみアップロード可能、{0}MB以内のもの',
    upload02: '最大20MBの動画がアップロード可能',
    upload03: '最大アップロード可能な数は',
    upload04: '枚の画像！',
    upload05: '個の動画！',
    upload06: 'このファイルの画像書式は無効です！',
    upload07: 'アップロードされる画像のサイズは{0}MBを超えてはいけません！',
    upload08: 'ファイル名にはコンマが入ってはいけません！',
    upload09: 'この動画ファイルの書式は無効です！',
    upload10: 'アップロードされる動画のサイズは20MBを超えてはいけません！',
    upload11: 'アップロード失敗！',
    upload12: 'アップロードエラー！',
    upload13: '実物券・カウンター・受付・施設の外観も合わせてご提供下さい',
    upload14: '一つの書類',
    upload15: 'アップロードしたファイルサイズを超えてはいけない 5MB！',
    calendar01: '年',
    calendar02: '月',
    calendar03: '当月の在庫を全て選択',
    calendar04: '件',
    clerkTable01: '未指定の場合は全スタッフが認証可能',
    week_1: '月',
    week_2: '火',
    week_3: '水',
    week_4: '木',
    week_5: '金',
    week_6: '土',
    week_7: '日',
    explain_1: '卸価格：システムに卸す価格。契約書内容を基準に定期的にシステムに請求する料金の単価',
    explain_2: 'AGT仕入価格：システムが旅行会社AGTに販売する価格',
    explain_3: '二つの料金の差額はシステムのコミッションになります',
    explain_4: '説明：在庫がない場合、「0」を記入。',
    explain_5: 'BtoB卸価格：ほかのプラットフォームシステムに卸す価格。卸価格との差額はEASYGOシステムの利益。',
    explain_6: '市場価格：参考としての一般価格',
    explain_7: '小売価格：AGTに対し、参考としてのBtoC価格。特に制限がない場合、市場価格と同じ金額で設定してください。',
    explain_8: '価額種類(日本語)入力説明：',
    explain_9: '大人料金',
    explain_10: '小児料金',
    explain_11: '身障者大人料金',
    explain_12: '身障者小児料金',
    explain_13: '(以下の価額種類のみ有効：大人、小児、身障者大人、 身障者小児)',
    explain_14: '(利用可能の日付を参考し、在庫を設置してください。利用不可の日付の設置は無効です。)',
    explain_15: '利用可能の日付：',
    explain_16: '現在の価額種類で利用可能の日付はありません。',
    explain_17: '販売状態',
    explain_18: '価格設定説明：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '販売中',
    notSale: '販売停止',
    productDeleteMessage: '先にパッケージ商品を削除してください。又はパッケージ商品の中から当該商品を削除してください！',
    none: 'なし',
    sendMailSet: '発送日を早める：',
    mailContent: 'メールの内容：',
    noSend: '発送しない',
    mailTime: '期日指定まで',
    mailContent_placeholder: 'メールの内容を入力してください',
    mailsetTips: 'PDFなしの電子チケットのみ対応'
  },
  recharge: {
    depositWithdraw: 'チャージ/現金引出',
    depositWithdrawHistoryRecord: 'チャージ/現金引出履歴',
    searchStr: 'ユーザー名/ID：',
    placeholder1: '店舗名/IDを入力してください',
    businessType: 'ユーザー種類：',
    businessType1: 'ユーザー種類',
    placeholder2: '選択してください',
    search: '検索',
    businessName: 'ユーザー名',
    businessName1: 'ユーザー名：',
    balance: '残高',
    accountBalance: 'アカウントの残高：',
    operation: '操作',
    deposit: 'チャージ',
    depositAuto: 'オンラインでチャージ',
    automatic: '自動チャージ',
    withdraw: '現金引出',
    record: '詳細',
    withdrawAvail: '現金引出可能な金額：',
    withdrawAmount: '現金引出金額：',
    withdrawRemark: '現金引出備考：',
    cancel: 'キャンセル',
    submit: '審査に送信',
    depositAmount: 'チャージ金額：',
    depositRemark: 'チャージ備考：',
    all: '全部',
    supplier: 'サプライヤー',
    distributor: 'AGT',
    submitSuccess: '送信ができました',
    subimitFailed: '送信に失敗しました',
    message: '現金引出の金額は現金引出可能な金額より大きい！',
    goBack: '戻る',
    dateRange: '時間帯：',
    placeholder3: '日付範囲を選択',
    date: '日付',
    operator: 'オペレーター',
    type: '種類',
    supplierWithdraw: '店舗の現金引出申請',
    platformWithdraw: 'プラットフォーム現金引出',
    operationAmount: '金額',
    remark: '備考',
    lastWeek: '最近一週間',
    lastMonth: '最近一ヶ月間',
    lastThreeMonth: '最近三ヶ月間',
    message2: 'チャージ金額は正の整数で入力してください！',
    message3: '現金引出金額は正の整数で入力してください！',
    message4: 'チャージ金額を2000,000,000の正の整数で入力してください！'
  },
  order: {
    batchSummary: 'バッチ詳細',
    canBeUseStartDate: '有効開始日',
    canBeUseEndDate: '有効終了日時',
    createUserName: '作成者',
    bulkPurchase: '一括購入',
    remarks: '備考欄',
    orderSource0: 'ToB',
    orderSource1: '施設toC',
    orderSource2: '対外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: 'Easygo',
    orderSource6: 'KKday',
    orderSource7: 'CK地図',
    orderSource8: 'AGT ToC',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '予約日',
    sourceType: 'システム',
    sourceJtr: 'JTR',
    sourceJph: 'EASYGO',
    allDate: '日付',
    productPrice: '単価',
    totalPrice: '総金額',
    orderInfo: '予約詳細',
    newSourceJtr: '運営者予約',
    payTime: '支払い時間',
    productUseDate: '指定利用日',
    cancelTime: '取消日',
    keyWorld: ' キーワード',
    distributor: 'AGT名',
    secondAgentId: '二級エージェントID',
    secondAgentCommission: '二級エージェント収益',
    productArea: '所在地',
    supplier: '施設名',
    search: '検索',
    synchronousTime_01: '（データ更新時間：',
    synchronousTime_02: '）',
    synchronousOrder_01: '更新リスト',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '認証日',
    validateDate: '有効期間',
    expirationTime: '有効期切れ日',
    timeSlot: '検索時間を選択か入力',
    searchMsg: '予約番号/商品名/お客様名前/お客様メールアドレス',
    channelOrderId: 'チャネル番号',
    searchDistributor: 'AGT名を入力',
    searchSupplier: '施設名を入力',
    orderExport: '予約一覧ダウンロード',
    ticketDepotExport: '倉庫一覧ダウンロード',
    ticketBatchDetailExport: 'パッチ明細一覧ダウンロード',
    productExport: '商品一覧ダウンロード',
    productExports: '商品一覧ダウンロード',
    orderId: '予約番号',
    sonOrderId: '分支予約番号',
    productName: '商品名',
    allBuyQuantity: '購入数',
    customerName: 'お客様名前',
    orderExplain: '備考欄',
    orderExplain1: '予約説明(AGTのみ表示の内部説明)',
    orderStatus: '予約状態',
    notPay: '未支払い',
    beConfirm: '確認待ち',
    beingCancel: 'キャンセル処理中',
    haveCanceled: 'キャンセル済',
    haveConfirmed: '予約済',
    beTicket: '確認待ち',
    batchHaveDone: '購入完了',
    haveDone: 'スキャン済',
    haveCancel: 'キャンセル済',
    haveRefundRequest: '返金申請済み',
    haveRefund: '返金済み',
    havePay: '支払い済み',
    failedPay: '支払い失敗',
    refuseRefund: '返金拒む',
    haveTicket: '予約済',
    notPayButCanceled: '未支払いで取消された予約',
    haveExpired: '有効期切れ',
    leftHandleTime: '予約処理期限',
    operation: '操作',
    addOrSub: '部分的にキャンセル',
    refund: '返金',
    beAdd: 'オーダー',
    addOrSubOrRefund: '部分取り消し/返金',
    source: 'QRコード',
    validateOrder1: '認証成功',
    validateOrder2: '当該予約の認証権限がございません',
    validateOrder3: '認証失敗',
    validateOrder4: '',
    date_empty: '日付形式が不正、もしくは過去の日付',
    myouji_kana_empty: '姓氏が不正、仮名か英文字を入力してください',
    namae_kana_empty: '名前が不正、仮名か英文字を入力してください',
    bin_key_id_empty: '便キーID パラメータが不正',
    sex_empty: '性別パラメータが不正',
    tel_empty: '電話番号が不正、10桁か11桁の数字を入力してください',
    email_empty: 'メールアドレスが不正、10桁か11桁の数字を入力してください',
    total_num_empty: '予約人数パラメータが不正',
    age_empty: '年齢が不正、数字を入力してください',
    emergency_phone_empty: '緊急時連絡先パラメータが不正',
    ctype_empty: '年齢区分・障害者区分パラメータが不正',
    recep_empty: '受付が終了している',
    num_over: '在庫不足のため予約できません',
    num_not_sale: 'ご選択の指定日はまだ販売開始していません',
    r_id_empty: '指定予約IDは既にキャンセル済み',
    r_id_already_cancel_ok: '',
    r_id_already_payment_ok: 'この予約は支払い済み',
    thirdMethodErr: '接続口異常、管理員にご連絡してください。',
    systemErr: 'システム異常、管理員にご連絡してください。'
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: 'チャージ/現金引出',
    withdrawalCashManager: 'チャージ/現金引出管理',
    withdrawalOnline: 'オンラインでチャージ',
    withdrawalOffline: '手動でチャージ',
    applyWithdraw: '現金引出を申請',
    beingHandel: '処理待ち',
    beingAudit: '審査待ち',
    notPass: '審査失敗',
    selectTimeSlot: '時間帯',
    selectDateSlot: '期間を選択',
    createTime: '作成時間',
    operationPeople: 'オペレーター',
    type: '種類',
    recharge: 'チャージ',
    withdraw: '現金引出',
    withdrawAmount: '現金引出金額',
    rechargeWithdrawAmount: '金額',
    rechargeWithdrawAmount2: '現金引出金額',
    remark: '備考',
    refundReason: '審査失敗理由',
    accountBalance: 'アカウントの残高',
    canWithdrawalBalance: '引き出し限度額',
    applyWithdrawalBalance: '申請する精算金額',
    applyWithdrawalBalance2: '申請する追加チャージ金額',
    selectWithdrawalAccount: '現金引出金額を入力してください',
    withdrawRemark: '現金引出備考',
    withdrawRemark2: 'チャージ備考',
    inputWithdrawRemark: '現金引出の備考情報を入力してください',
    cancel: 'キャンセル',
    sure: '確認',
    submitResigt: '申请を送信',
    oneWeek: '最近一週間',
    oneMonth: '最近一ヶ月間',
    threeMonth: '最近三ヶ月間',
    withdrawAmoutIsNotNull: '現金引出金額は空白にしてはいけません！',
    withdrawAmoutZS: '正の整数で入力してください！',
    withdrawAmoutMustNumber: '現金引出金額は数字でないといけません！',
    withdrawAmoutIsNot0: '現金引出金額は0以上でないといけません！',
    withdrawAmoutIsNotNegative: '現金引出金額はマイナスではいけません！',
    withdrawAmoutIsNotEnough: '現金引出可能な残高が足りません！',
    comformWithdrawMsg: '現金引出情報を確認してください。継続しますか？',
    comformWithdrawMsgIfGo: '現金引出情報を確認してください。継続しますか？',
    sureSubmit: '確認して送信',
    returnEdit: '戻る',
    submitSuccess: '送信できました。審査をお待ちください！',
    companyName: '店舗名',
    companyName2: '店舗名',
    companyType: '店舗種類',
    distributor: 'AGT',
    supplier: 'サプライヤー',
    inputCompanyNameAndId: '店舗名/IDを入力してください',
    handle: '処理',
    auditor: '審査',
    auditorPass: '審査通過',
    auditorNotPass: '審査不合格',
    withdrawHander: '現金引出処理',
    withDrawAuditor: '現金引出審査',
    withDrawAuditor2: 'チャージ審査',
    withdrawHander2: 'チャージ処理',
    refuseApply: '申请を拒否',
    refuseApplyReason: '審査に通らない理由を入力してください',
    handlingSubmittingAudits: '審査に送信',
    handelSuccess: '処理できました！',
    rechargeFail: 'チャージ失敗'
  },
  password: {
    getPassword: '「パスワード」をお忘れの方はこちら',
    pleaseInputMailAccount: 'メールアドレスを入力してください',
    sendPasswordToMail: 'パスワードをメールアドレスに送信',
    returnToIndex: '戻る',
    sendMsg: '業務責任者のメールアドレスを入力してください。システムより初期パスワードをお送りします。',
    mattersNeedingAttention: '注意事項',
    tips1: '「パスワードの初期化申請」機能を頻繁に利用しないでください。一日最大の利用回数は',
    tips2: '回です。',
    tipsMsg: '通知メッセージ',
    loginAtonce: 'ログイン',
    getUrlAgain: 'メール再送',
    mailCanNotBeEmpty: 'メールアドレスは空白ではいけません！',
    mailStyleNotRight: '有効なメールアドレスを入力してください！',
    mailHaveSendSuccess: 'メールはご利用のメールアドレスに送信されました。ご確認ください！',
    theMailInputNotExist: '入力されたメールアドレスは存在していません！',
    theMailNotHaveRight: '当該メールボックスはアクティブにならなかったか、無効化されました！',
    aboveOneDayPermit: '一日の最大操作回数を超えました！',
    mailSendFail: 'メールの送信は失敗しました！'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: 'メールアドレスを入力してください。',
    emailError: 'メールボックスの入力フォーマットが不正です。',
    confirmEmailError: '確認用E－mailの書式は正しくありません。',
    pleaseIntoUseDate: '利用時間を選択してください',
    pleaseIntprodDate: '利用日を選択してください',
    pleaseIntoHandDate: '受領時間を選択してください',
    pleaseIntoReturnDate: '返却日付を選択してください',
    pleaseIntoLinkCounter: '受領カウンターを選択してください',
    pleaseIntoReturnCounter: '返却カウンターを選択してください请选择归还柜台',
    pleaseIntoCustomEmail: '観光客の名前を入力してください',
    pleaseSelectStock: '時間帯を選択してください',
    customEmailLength: 'お客様の名前の長さは20ケタ超えないように',
    pleaseIntoCustomTel: 'お客様の携帯番号を入力してください',
    pleaseIntoNationality: 'お客様の国籍を入力してください',
    pleaseIntoBirthday: 'お客様の诞生日を入力してください',
    customTelError: 'お客様の携帯番号の書式は正しくありません',
    customTelError1: '無効の電話番号、10桁或いは11桁有効の電話番号を入力してください。',
    customAgeError: '正しい年齢をご入力ください。',
    customSexError2: '女性専用車のため、性別を再選択してください。',
    customSexError1: '男性専用車のため、性別を再選択してください。',
    pleaseIntoCustomWechat: 'お客様のWechatアカウントを入力してください',
    customWechatError: 'お客様のWechatアカウントの書式は正しくありません',
    pleaseIntoCustomPass: 'パスポート番号を入力してください',
    customPassError: 'パスポート番号の書式は正しくありません',
    pleaseIntoCustomAddress: '宅便アドレスを入力してください',
    pleaseIntoCustomPostcode: '郵便番号を入力してください',
    customPostcodeError: '郵便番号の形式は不正確です',
    pleaseIntoCustomCreditType: '証明書類型を選択してください',
    pleaseIntoCustomCreditNo: '証明書番号を入力してください',
    customCreditNoError: '証明書番号の形式は不正確です',
    customSexMale: '男',
    customSexFalmale: '女',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '購入希望の価額種類と券種は一致しません、改めて選択してください。',
    pleaseIntoCustomItem: 'お客様のカスタマイズ内容を入力してください',
    quotaPrompt: '0より大きい整数を入力してください。',
    orderOnceBeOne: '予約数は少なくとも1つです',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '一度に予約を受けられる数の上限は',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '本商品の予約数は少なくとも',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '有効期限切れのため、予約できません',
    productsNumError: '在庫不足のため、予約できません。',
    productsNumError1: '商品 ',
    productsNumError2: ' - :',
    productsNumError3: ' 在庫不足',
    productsNumError4: ' PDFファイル在庫不足',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: 'システム異常,再度試みてください!',
    pleaseUploadPDF: 'PDFファイルをアップロードしてください！',
    pleaseIntoUseData: '指定の日付を入力してください',
    productUseDateBeNull: '注文の指定の日付は空白にしてはいけません',
    jtrordermessage: '数量上限は',
    jtrplayDate: '利用日を選択してください',
    jtrnum: '数量を選択してください',
    jtrphone: '携帯番号を入力してください',
    jtrphonefalse: '携帯番号は不正確です',
    linkCreditTypeErr: '証明書類型を選択してください',
    linkCreditNoErr: '証明書番号を入力してください',
    error: '予約は追加できません、上限になりました',
    limitedDate: '現時点が商品の予定可能時間を超えました、再予約をお願い致します。',
    limitBulking: '当該AGTは一括購入中です、購入完了の前に新しいバッチ予約を送信できません、しばらくお待ちください!',
    designatedDateNull: '指定日が空です'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '金額を入力してください',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '追加成功',
    addError1: '追加失敗、商品が既に存在か未選択です',
    addError2: '追加失敗',
    submitPrice: '価格は空にしてはいけません!',
    submitMinPrice: '最低価額を入力してください',
    submitMinPrice0: '最低価額は正数しか設定できません',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: 'ソート順は空にしてはいけません!',
    submitLength: 'ソート順と価格は数字10位以下にしてください',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '精算期間：',
    calculatePeriod1: '精算期間',
    placeholderCalculatePeriod: '精算期間を選択してください',
    supplierNameAndId: '店舗名/ID：',
    placeholderSupplierNameAndId: '店舗名/IDを入力してください',
    search: '検索',
    supplierName: '店舗名',
    distributorPayoutAmount: '販売金額（JPY）',
    operatorIncomeAmount: 'システム手数料（JPY）',
    supplierIncomeAmount: '精算金額（JPY）',
    operation: '操作',
    detail: '詳細',
    downloadBill: '明細ダウンロード',
    lastSixMonth: '最近六ヶ月間',
    return: '戻る',
    distributorName: 'AGT名',
    distributorName1: 'AGT名',
    placeholderDistributorName: '販売店名/IDを入力してください',
    finishTime: '完成時間',
    orderId: '注文番号',
    productId: '商品番号',
    productName: '商品名',
    productType: '商品種類',
    elecTicket: '電子チケット',
    paperTicket: '実物券',
    experTicket: '体験',
    daysTicket: 'ツアー',
    wifi: 'Wi-Fi',
    sim: 'SIMカード',
    restTicket: 'レストラン',
    traffTicket: '交通',
    packTicket: 'お得セット商品',
    distributorPayoutAmount1: '支払い金額',
    operatorIncomeAmount1: 'コミッション金額',
    supplierIncomeAmount1: '精算金額(JPY)'
  },
  payOrder: {
    payMessageOne: '注文の詳細情報を最終確認してください、1時間内に支払わないとキャセルされてしまい、なるべく早く支払ってください。',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '注文書を確認して、注文書は',
    jtrcancel: '部分的に注文キャンセル',
    jtrAppend: '予約追加',
    jtrpayMessageTwo: 'もし　分以内に未払い状態で、キャンセルさせます',
    payMessageTwo: '出来るだけ早くお支払いください。もし製品が売れ切りになりましたら、購入できなくなります。',
    payMessageThree: '注文',
    payMessageFour: '分内に支払わないとキャセルされてしまい、なるべく早く支払ってください。',
    payMessageFive: 'タイムアウトでもう一回注文してください。',
    lineDownTicket: 'オフライン電子チケット',
    lineUpTicket: 'オンライン電子チケット',
    salaryByNow: 'プリペイドで支払う',
    thirdPayment: 'Eウォレット決済',
    canBeUseMoney: 'アカウントの利用可能な残高：',
    jtrcanBeUseMoney: '支払い金額',
    remainTimes: '有效时间',
    payMoney: '支払う：',
    applyCancel: '注文をキャンセル申し込み',
    payByNow: 'すぐに支払う',
    canBeUseMoneyError: '利用可能な残高が足りないため、予約できません',
    orderCanceled: '注文はキャンセル済み',
    consentRefund: '返金する',
    refuseRefund: '返金拒む',
    overTimeByPay: 'タイムアウトで注文が自動的に取消します',
    orderHaveUpdate: '支払い失敗、予約状態が更新しました',
    orderException: '予約異常，再度試みてください',
    productException: '商品異常,説明は編集できません',
    payerror: '支払い失敗',
    error: 'キャンセルの数量が間違いた',
    applyerror: '申請失敗'
  },
  supplyOrder: {
    confirmCancel: '取消を確認',
    refuseCancel: '取消を拒否',
    canceleOrder: '予約キャンセル',
    specialCanceleOrder: '特殊キャンセル',
    partnerCancleOrder: '接続先APIキャンセル',
    jtrSpecialCanceleChannel: 'パス券特殊キャンセル',
    writeFff: '認証',
    confirmSpecialRefund: '特殊返金する',
    refuseSpecialRefund: '特殊返金拒む',
    orderConfirmDetail: '予約内容確認',
    system: 'システム',
    checkedForNew: 'クリックして新しいメッセージを閲覧',
    orderRefuseMessage: '本商品は返金できない商品であり、もし取消を申請されれば、支払われた金額は返金できませんが、ご了承ください。',
    canBeTakeBackFree: '返金手数料率',
    canBeTakeBack: '返金手数料',
    exchangeRate: '汇率差额',
    takeMoney: '実際の返金額',
    orderDetailByDialog: '注文の詳細情報を確認',
    orderdetail1: '確認シート①',
    orderdetail2: '確認シート②',
    orderdetail3: '確認シート③',
    orderdetail4: '確認シート④',
    orderdetail5: '確認シート⑤',
    orderdetail6: '確認シート⑥',
    orderdetail7: '確認シート⑦',
    orderdetail8: '確認シート⑧',
    orderdetail9: '確認シート⑨',
    fileTypes: '当該ファイルは有効なPDFではありません！',
    reselectFile: '当該ファイルにPDFが含まれていません、再選択してください!',
    zipTypes: '当該ファイルは有効なZIPではありません！',
    fileSize: 'アップロードされるPDFのサイズは5MBを超えないように！',
    fileTypeBy: 'ファイル名にコンマを入れないでください！',
    canCancel: 'キャンセル',
    downFiles: 'ファイルをダウンロード',
    vailTimeMsg: '予約済み状態の予約しか変更できません',
    vailTimelaterMsg: '終了日は現在の日付より前にすることはできません',
    vailTimeFsjMsg: '富士急ハイランド商品の予約の有効期間は変更できません',
    vailTimeEmpty: '有効期間を選択してください'
  },
  productNumberPrice: {
    pleaseIntoTime: '時間を選択してください',
    pleaseIntoNumber: '在庫を記入してください',
    pleaseGetOneToSix: '1から6個の数字を入力してください',
    pleaseIntoPurchasePrice: '卸価格を入力してください',
    pleaseIntoDistorbutionPrice: 'AGT仕入価格を入力してください',
    pleaseIntoMarketPrice: '市場価格を入力してください',
    dateCanotBeNull: '日付の範囲は空白にしてはいけません',
    confirmDateCanotBeMax: '設定の時間帯は製品が有効時間帯範囲内にしないといけません！',
    distributorCanotBuyMessage: '当該商品の販売権がないため予約できません',
    distributorCanotBuyMessage2: '当該商品が販売中止であるため予約できません'
  },
  pwdSet: {
    pleaseIntoOldPwd: '現在のパスワードを入力してください',
    pleaseIntoNewPwd: '新しいパスワードを入力してください',
    pleaseConfirmPwd: '新しいパスワードを確認してください',
    pleaseIntoIntoSix: '6-16ケタの英文字(大、小)又は数字を入力してください',
    mustBeOne: '上記と一致しないといけません',
    pleaseIntoCorrectPwd: '正しいパスワードを入力してください',
    lengthMustOneToSix: '長さは６ケタから１6ケタまでにしてください',
    canotBeIntoNull: 'スペースやその他の特殊記号は入力してはいけません',
    updateNewPwdSuccess: 'パスワードは変更されました。ログインし直してください！',
    oldPwdError: '現在のパスワードは正しくありません、もう一度入力してください！',
    oldAndNewNotOne: '二回入力されたパスワードは一致していません！',
    pleaseIntoMustItem: '必須項目を入力してください',
    pleaseEnterPwd: 'パスワードを入力してください',
    pleaseEnterPwdAgain: 'もう一度パスワードを入力してください'
  },
  homeMessage: {
    urgnMessage: '操作の権限がありません！'
  },
  entityTicket: {
    pinTicketNo: '認証番号',
    selectDepot: '倉庫選択',
    pleaseSelect: '選択してください',
    selectProduct: '製品選択',
    relationProduct: '関連商品',
    selectPriceType: '種類選択',
    saveTicketDepot: 'チケット倉庫を保存',
    onlySelectOnePro: 'チケット倉庫を追加時に製品が一つだけ選べる!',
    onlySelectOnePriceType: 'チケット倉庫を追加時に種類が一つだけ選べる!',
    depotNameNotBeEmpty: '倉庫は空白にしてはいけません!',
    productNameNotBeEmpty: '製品は空白にしてはいけません!',
    productPriceTypeNotBeEmpty: '種類を選択してください!',
    addSuccess: '追加できました!',
    inDepotSuccess: '倉庫に入れました!',
    proHaveExist: '当該製品は既に存在!',
    selectDepotOut: 'エクスポート倉庫',
    selectDepotIn: 'インポート倉庫',
    depotProNum: '在庫数',
    validDate: '有効期限',
    selectDate: '日時を選択',
    starEndTicketNo: '両側チケット番号',
    starTicketNo: '最初のチケット番号',
    endTicketNo: '最後のチケット番号',
    inDepotTicketNo: 'インポートチケット番号',
    textArea: 'スキャンポータル-カーソルをここに移動し、スキャナーでチケット上のコードをスキャンしてください',
    saveToDepot: 'インポートを保存',
    pleaseInputStarTicketNo: '最初のチケット番号を入力してください!',
    pleaseInputEndTicketNo: '最後のチケット番号を入力してください!',
    errorMsg01: '最初のチケット番は10桁以下の数字!',
    errorMsg02: '最後のチケット番は10桁以下の数字!',
    errorMsg03: '最初のチケット番号は最後のほど大きくないように!',
    errorMsg04: 'インポートチケット数は2000枚以内!',
    errorMsg05: '下記のチケット番号の長さは10桁以上',
    errorMsg06: 'インポート倉庫を選択してください!',
    errorMsg07: 'エクスポート倉庫とインポート倉庫は一致してはいけません!',
    errorMsg08: '締切時間を選択してください!',
    errorMsg09: 'インポートチケット番号を入力してください!',
    errorMsg10: 'このインポート倉庫と当該製品はまだチケット倉庫がないので、まずチケット倉庫を作成してから製品をインポートしてください!',
    errorMsg11: 'インポート倉庫に下記のチケット番号が存在している',
    errorMsg12: 'エクスポート倉庫に下記のチケット番号が存在していない',
    errorMsg13: 'このエクスポート倉庫と当該製品はまだチケット倉庫がないので、まずチケット倉庫を作成してから製品をエクスポートしてください!',
    allBathList: 'バッチ一覧',
    batchDetailList: 'バッチ明細一覧',
    batchNO: 'バッチ番号',
    ticketNO: 'チケット番号',
    pleaseInputBatchNo: 'バッチ番号を入力してください',
    pleaseInputTicketNo: 'チケット番号を入力してください',
    inDepotTime: '入庫時間',
    inDepotUser: '入庫ユーザ',
    importNumber: '総数',
    userNumber: '利用数',
    invalidateNumber: '無効化数',
    leftNumber: '残りの数',
    exportNumber: '出庫数',
    thisBatchDetail: '明細',
    clearDepot: 'クリア',
    batchState: 'バッチ状態',
    ticketState: 'チケット状態',
    stateOne: '正常',
    stateTwo: '使用済',
    stateThree: '無効化',
    stateFour: '出庫済',
    stateFive: 'クリア済み',
    stateSix: 'ロック済',
    userOperationTime: '利用（無効化）時間',
    unUseRemark: '無効化説明',
    orderId: '予約番号',
    sureClearDepot: '本当にこのバッチの製品をクリアしますか?',
    sureClearDepot2: '本当にこの製品を倉庫クリアしますか?',
    clearDepotSuccess: '倉庫クリアに成功',
    haveCancelClearDepot: '倉庫クリア操作取消済!',
    invalidTicketSuccess: '全て無効化に成功!',
    addTicketDepot: 'チケット倉庫追加',
    depot: '倉庫',
    keyWorld: 'キーワード',
    inputProNameAndNo: '製品名/番号を入力してください',
    userTimeQuantum: '利用時間帯',
    inputSelectTimeQuantum: '検索時間帯を選択か入力',
    depotId: '倉庫ID',
    ticketDepotId: 'チケット倉庫ID',
    depotName: '倉庫名',
    productId: '製品ID',
    productName: '商品名',
    fileName: 'ファイル数',
    depotIn: '入庫',
    depotId2: '入庫',
    depotId3: '→',
    depotId4: '新規入庫',
    depotOut: '出庫',
    history: '履歴',
    zhang: '枚',
    operationUser: 'オペレーター',
    depotType: '倉庫種類',
    addDepot: '倉庫新規追加',
    inputDepotName: '倉庫名を入力',
    notAllDepot: '非ヘット倉庫',
    allDepot: 'ヘット倉庫',
    depotRemark: '倉庫備考',
    remarkMsg: '備考情報',
    inventoryNumber: '在庫数',
    ifIsAllDepot: 'ヘット倉庫か',
    yes: 'はい',
    no: 'いいえ',
    tips: '備考:ヘット倉庫は一つしかありません',
    depotEdit: '倉庫編集',
    deleteDepot: '本当にこの倉庫を削除しますか?',
    depotNameIsNotEmpty: '倉庫名は空白にしてはいけません!',
    allDepotOnlyOne: 'ヘット倉庫は一つだけ!',
    depotNameOnlyOne: '倉庫名は既に存在!',
    userDepotManager: 'ユーザ倉庫管理',
    addDepotToUser: '倉庫指定',
    addDepotToUserSuccess: '指定成功!',
    notHistory: '当該製品に履歴がありません!',
    pleaseSelectInvalidTicket: '無効化するチケット番号を選択してください!',
    invalidTicketFalid: '全て無効化に失敗!',
    someInvalidTicketFalid: '以下の票号は無効になりました',
    orderQuery: '注文の問い合わせ：',
    orderQueryPlac: '注文番号を入力、あるいはスキャンコードを示してください',
    orderInfo: '注文情報：',
    startStopNumber: '両側チケット番号：',
    startNumber: '最初のチケット番号',
    stopNumber: '最後のチケット番号',
    numberEditPlac: 'スキャンポータル-カーソルをここに移動し、スキャナーでチケット上のコードをスキャンしてください',
    confirmPin: '消去確認',
    formMsg1: '確認コードあるいは注文番号を入力、あるいはスキャンコードを示してください',
    rule_n1_10: '長さが1から10ケタの数字にしてください',
    querySuccess: 'クエリ成功',
    queryFailure: '注文は存在していません',
    queryMsg1: '始めの番号は終わりの番号より小さい、一回は100枚に限る',
    queryMsg2: '消去確認：',
    pinMsg1: '消去成功',
    pinMsg2: '消去失敗!',
    clearRemark: '清倉の備考'
  },
  ticketMessage: {
    pleaseEnterOrderId: '予約番号を入力してください',
    depotName: '倉庫名：',
    pleaseIntoDepotName: '倉庫名を入力してください',
    depotNameNotNull: '倉庫名は空白にしてはいけません',
    ticketRemark: '備考：',
    remarkNotNull: '備考は空白にしてはいけません',
    pleaseGetProduct: '製品を選択してください',
    fileDepotName: 'ファイル倉庫名：',
    batchStatus: 'バッチ状態：',
    batchId: 'バッチ番号',
    pleaseEnterBatchId: 'バッチ番号入力',
    enterDate: 'インポート時間',
    enterUser: 'インポートユーザ',
    close: '閉じる',
    Processing: '処理中',
    uploadFailure: 'アップロードに失敗しました',
    ticketDetail: '詳細',
    newToUse: '優先使用',
    fileStatus: 'ファイル状態：',
    fileName: 'ファイル名：',
    pleaseEnterFileName: 'PDFのファイル名を入力してください',
    fileId: 'ファイルID',
    fileNames: 'ファイル名',
    downPdf: 'PDFダウンロード',
    ticketMessageBy: '下記のチケット番号状態が異常なため、無効化失敗！',
    noUseMessage: '少なくても一つのファイルを選択！',
    ticketMessageBy2: '今回の操作には異常なチケットがあり、リフレッシュ後再度試してください！',
    operationSuccess: '操作成功!',
    getFile: 'ファイル選択',
    getZipFile: 'ZIP選択',
    getFilesOnlyFive: '*各PDFはページごとに複数の電子チケットに分割されます。アップロードPDFファイルの最大数は5，且つ1つのファイルの最大サイズは10MB',
    getZipOnlyOne: 'アップロードZIPファイルの最大数は1，ファイルの最大サイズは300MB',
    usedDate: '有効な締切：',
    usedDates: '有効な締切',
    ticketMessageBy3: '空白ならずっと有効。',
    intoNow: 'すぐにインポート',
    intoSuccess: 'インポート成功!',
    insertFileDepot: 'ファイル倉庫新規追加',
    choose: '選択',
    fileDepotNames: 'ファイル倉庫名',
    pleaseIntoFileName: 'ファイル倉庫名を入力してください',
    canBeUseDate: '利用（無効化）時間帯：',
    intoSearchDate: '検索時間帯を選択か入力',
    into: 'インポート',
    fivePdf: '部のPDF!',
    oneZip: '部のZIP!',
    ticketOpen: '開く',
    intoIng: '導入中，少々お待ちください...',
    fileHadExists: 'ファイルデータベースは既に存在しています！',
    uploadSize: 'アップロード写真の最大サイズは10MB！',
    uploadZipSize: 'アップロード写真の最大サイズは300MB！',
    fileNotFors: 'アップロードファイルは繰り返してはならない！',
    pleaseGetFile: 'ファイルを選択してください',
    fileBatchRemarkNotNull: '備考情報を入力してください'
  },
  remind: {
    remindId: '番号',
    title: 'メールによる注意喚起',
    date: '結団日',
    accessory: '添付ファイル',
    add: '新築の注意',
    upload: '添付ファイルをアップロードする',
    beforeDay: '発団日のN日前までに注意メールを送る',
    before: '発団日前',
    days: '日メールで注意喚起',
    download: '添付ファイルをダウンロードする',
    reminder: '提示',
    confirm: '確定',
    inputDate: '結団日を入力してください',
    uploadAccessory: '添付ファイルをアップロードしてください',
    inputbeforeDay: '繰り上げ発送日を入力してください',
    inputContent: 'メールの内容を入力してください',
    sendContent: '送信内',
    addRemind: 'メールによる注意喚起',
    existRemind: '当日注意はすでに存在している',
    set: 'メール設定'
  },
  trades: {
    platform: 'プラットフォーム',
    excel: 'エクスポート EXCEL',
    tradesTime: '取引時間帯',
    inputOrderId: '注文番号を入力してください',
    tradingTime: '取引日付',
    operatorUser: '作業員',
    expenditure: '支出',
    income: '収入',
    buyQuantity: '数量',
    customerName: 'お客様名前',
    orderExplain: '予約備考',
    content: '内容'
  },
  pinTicketMagn: {
    pinTicket: '認証出庫',
    shortcutOut: 'ショート消去',
    all: '全部',
    pinTime: '認証時間',
    validationType: '消去タイプ：',
    productName: '製品名：',
    placeholder1: '製品名を入力してください',
    validateTime: '消去日期：',
    placeholder2: '消去日期を選んでください',
    orderId: '注文ID：',
    placeholder3: '注文IDを入力してください',
    distributor: 'AGT：',
    placeholder4: '販売店を入力してください',
    validationUser: '消去人：',
    placeholder5: '消去人を入力してください',
    ticketNo: 'チケット番号：',
    placeholder6: 'チケット番号を入力してください',
    colOrderId: '注文ID',
    colOrderContent: '注文の内容',
    colValidateTime: '消去時間',
    colValidateType: '消去タイプ',
    colValidateUser: '消去人',
    colDistributor: 'AGT',
    colCustomerOrderNo: 'ショート番号',
    placeholder7: 'ショート消去番号を入力してください',
    colCustomerOperator: 'オペレーター',
    placeholder8: '担当者を入力してください',
    colticketNo: 'チケット番号',
    shortcutOutDepot: '消去倉庫',
    shortcutOutProduct: '消去制品',
    company: '会社',
    orderIdNo: '注文ID',
    distributorNameAndOrderNo: 'AGT名 (例：頭文字) ＋予約番号',
    pleaseInputOrderCustomer: '顧客の注文IDを入力してください',
    pleaseInputCustomerOperator: 'オペレーターを入力してください',
    shortcutOutSure: '消去確認',
    ticketCanNotBeCutOut: '以下は消せない',
    ticketCanNotBeCutOuts: '重複したチケット番号を入力することはできません',
    distributeOnlySelectOne: 'ディストリビューターは一つしか選ばない',
    ticketNumber100: 'チケット数は100まで!',
    pleaseInputDistribute: '販売店を選択してください!',
    pleaseInputOrder: '注文IDを入力してください!',
    orderLine100: '注文IDの長さは100ケタ超えないように!',
    inputOperation: 'オペレーターを入力してください!',
    operationLine100: 'オペレーターの長さは100ケタ超えないように',
    shortcutOutSuccess: '消去成功!'
  },
  errMsg: {
    errMsg100: '注文は存在していません',
    errMsg101: '一致する倉庫がない',
    errMsg102: 'オペレータだけ操作可能',
    errMsg103: '注文は有効期間外',
    errMsg104: '以下は消せない',
    errMsg105: '運営業者か特別権限のあるサプライヤーより直接審査通過の操作が失敗した',
    errMsg106: '製品IDは空白にしてはいけません',
    errMsg107: 'ファイルをアップロードは空白にしてはいけません',
    errMsg108: 'サーバー内部異常',
    errMsg109: '当該予約は既に認証済みです。',
    errMsg110: '注文は確認待ち',
    errMsg111: '切符消去数と実際の購入数が合わない',
    errMsg112: '一致する切符倉庫がない',
    errMsg113: '一致する切符がない',
    errMsg114: '接続先システムを選択してください',
    errMsg115: 'チケット番号を最少に一つを入力してから、確認してください。',
    errMsg116: '当該予約はキャンセルされました',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '処理中のため、重複操作はおやめください。'
  },
  pay: {
    type: 'チャージ方法',
    success: '支払い完了',
    fail: '支払い未完成',
    toUrl: 'ご選択の支払いプラットフォームでお支払ください',
    toPay: '続けてチャージ',
    error01: '支払い失敗、再度お試しください',
    error02: '支払いは完了しました、重複操作しないでください',
    loading: '支払いデータは処理中…',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: 'jpg/png/jpegのみアップロード可能、1MB以内',
    upload02: 'サイズは1920x500画素であり、ホームページ写真は左側との距離が430画素を必要',
    pageImg: 'ホームページ写真：',
    errorByPage01: 'ホームページ写真が変化無し',
    errorByPage02: 'ホームページ写真は空であることができない！'
  },
  barCode: {
    urlError: 'アドレスリンク異常!',
    getInfoError: 'QRコード読み込み異常!',
    productTextDescription: '予約内容',
    customerReceiveDate: '受領日付：',
    returnDate: '返却日付：',
    productUseDate: '指定利用日：',
    buyQuantity: '購入数：',
    productUseFlow: '利用手順：',
    productUseName: '名前：',
    validityDate: '有効時間：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: 'QRコード名',
    isDistribution: '販売店',
    scale: 'コミッション比率',
    YES: 'オン',
    NO: 'オフ',
    noValue: 'なし',
    distributionRange: '販売権設定',
    distributionRangeAll: '全てのQRコードが販売可能',
    distributionRangeYes: '指定QRコードのみ販売可能',
    distributionRangeNo: '指定QRコード以外は販売可能',
    selectDistributor: '商品選択',
    tipMessage1: 'QRコード名を入力してください',
    tipMessage2: '販売権を選択してください',
    tipMessage3: 'コミッション比率を入力してください',
    addError1: 'QRコード名が既に存在しているため、再度入力してください',
    prompt: 'QRコードを削除しますか？',
    searchMore: '商品一覧',
    choseCode: 'QRコードを選択',
    choseCodeError: 'QRコードを選択してください',
    nickName: 'ニックネーム',
    auditStatus: '審査状態',
    submitAudit: '審査を同意します？',
    submitAudit1: 'この現金引き出しを同意しますか？',
    cannotSale: 'ユーザーを無効後、QRコードを通じて購入した商品は、手数料の分配は行いません',
    canSale: 'ユーザーを有効後、QRコードを通じて購入した商品は、手数料の分配は行います',
    remark: '備考',
    agree: '同意',
    handle: '処理',
    notAgree: '却下',
    applyMoney: '引き出し金額',
    applyMoney1: '引き出し金額(手数料抜き)',
    chargeMoney: '手数料',
    chargeMoney2: '手数料込み',
    aduitTime: '審査時間',
    aduitName: '審査人',
    remittanceExport: '振込みデータダウンロード',
    realName: '口座名義',
    bankNo: '口座番号',
    bankName: '銀行名',
    branchName: '支店名',
    accountType: '口座種類',
    tocDistributor: '所属エージェント',
    distributorName: '二級エージェントニックネーム',
    twoDistributor: '二級エージェント',
    oneDistributor: 'エージェント',
    drawaltip1: '引き出し金額が残高を超えてます',
    drawaltip2: '引き出し金額が手数料より少ない',
    drawaltip3: '引き出し金額を入力して下さい',
    drawaltip4: '処理中の現金引き出し申請が御座います、処理完了までお待ちください',
    saleName: 'ユーザー',
    saleMoney: '二級エージェント収益',
    distributorMoney: 'エージェント収益',
    isHasMoney: '入金状態',
    isPay: '入金済み',
    notPay: '未入金',
    handleStatus: '処理状態',
    handleStatus1: '処理待ち',
    handleStatus2: '処理済',
    handleStatus3: '却下済',
    handleBy: '処理人',
    handleTime: '処理時間',
    setCharge: '手数料設置',
    chargeConfirm: '引き出し手数料の変更を確定しますか？',
    accountStatus: 'アカウント状態',
    canUse: '有効にする',
    cannotUse: '無効にする',
    cannotUse1: '連携解除済み',
    incomeAmount: '収益金額',
    tocIncomeAmount: 'C端アカウント残高',
    withdrawalError1: '口座名義を入力して下さい',
    withdrawalError2: '口座番号を入力して下さい',
    withdrawalError3: '銀行名を入力して下さい',
    withdrawalError4: '支店名を入力して下さい',
    withdrawalError5: '預金種目を入力して下さい',
    handleError1: '当ユーザー残高不足、引き出し処理できません',
    handleError2: '引き出し処理は運営ユーザーのみ操作可能',
    handleError3: '残高不足、引き出し処理できません',
    withdrawalTips: '日本円一万円以上（一万円も含む）の場合は無手数料;日本円一万円以下、固定手数料が発生します',
    withdrawalTips1: '日本円一万円以上（一万円も含む）の場合は無手数料',
    withdrawalTips2: '日本円一万円以下、固定手数料が発生します',
    applyCash: '引き出し申請',
    applyBy: '申請者タイプ',
    applyUser: '申請者',
    twoApplyName: '二級エージェント',
    cannotCharge: '金額は整数しか設定できません',
    name: '名称',
    Unbundling: '連携解除',
    UnbundTips: '連携解除後、このユーザーには販売コミッションが発生しなくなります。',
    cannotUnbund: '振込未完了のコミッションが御座います。連携解除できません。',
    twoApplyNameID: '二級エージェントID',
    inputScale: '分配するコミッション率を入力して下さい',
    keyTips: '二級エージェントID/二級エージェントニックネーム',
    saleLog: '直販記録',
    withdrawalTips4: '残高不足、引き出しを申請できません。'
  },
  payWay: {
    balance: '残高',
    weChat: 'Wechat',
    alipay: 'アリペイ',
    creditCard: 'クレジットカード',
    unionPay: '銀聯',
    weChatWay: 'ウィチャットペイ',
    payedId: '決済番号',
    alipayWay: 'アリペイ',
    linePay: 'Line決済',
    grabPay: 'Grab決済',
    zaloPay: 'Zalo決済',
    aliPayHK: 'アリペイ香港',
    isPay: '予約決済中',
    codeTips: 'QRコード有効期切れ、再取得してください',
    codeTips1: 'QRコード再取得',
    codeTips2: 'ウィチャットで',
    codeTips3: 'QRコードをスキャン',
    codeTips4: 'アリペイで',
    codeTips5: 'QRコードをスキャン',
    codeTips6: 'カメラで',
    refundTips: '予約はキャンセルされました、お支払いの全額はお支払元に返金致します。ご査収の程よろしくお願いします。',
    refundTips1: '予約は既に支払い済み、お支払いの全額はお支払元に返金致します。ご査収の程よろしくお願いします。',
    refundTips2: '予約の支払い方法により、支払い30日お超えた場合に返金できません、ご了承ください。',
    refundTips3: '予約のお支払いが失敗しました、既にお支払いした場合、お支払元に全額を返金致します。ご査収の程よろしくお願いします。',
    errorTips: '決済情報を取得できませんでした、再取得してください。',
    partialRefundTips: '一部返金の場合、手数料は返金されません',
    payTitle: '接続先商品予約決済'
  },
  newHome: {
    priceFormat: 'JPY {0} <span class="price-format">き</span>',
    expired: 'ログインが期限切れです。再度ログインしてください。',
    searchPlaceholder: '行き先・アクティビティを入力',
    searchButton: '検索',
    searchResults: '件の結果が見つかりました',
    category: {
      transport: '交通',
      themePark: 'チケット',
      wifi: ' Wi-Fiレンタル・SIMカード',
      carRental: 'お得なセット商品',
      dayTrip: 'ツアー・観光',
      hotel: '体験 & レストラン'
    },
    productSaleLabel: {
      osakaSalesOffice: '大阪営業所',
      tokyoSalesOffice: '東京営業所',
      fukuokaSalesOffice: '福岡営業所',
      kyotoSalesOffice: '沖縄営業所',
      nagoyaSalesOffice: '名古屋営業所',
      hokkaidoSalesOffice: '北海道営業所'
    },
    popularCities: '人気のスポット',
    popularCitiesEn: '人気スポット＆季節限定イベント特集',
    activeNumber: 'アクティビティ数',
    balance: '残高',
    switchToOldVersion: '旧版に切り替え',
    switchToNewVersion: '新版に切り替え',
    viewMore: 'もっと見る',
    all: 'すべて',
    sortBy: '並び替え',
    easyGoRecommend: 'EasyGoおすすめ',
    allDates: '日付',
    priceRange: '価格帯',
    other: 'その他',
    selectedExperiences: 'おすすめアクティビティ',
    topActivities: '日本の人気アクティビティ',
    sales: '予約数',
    price: '価格',
    stockQuery: '空き状況を確認',
    noProducts: '該当する商品がありません',
    salesLessThan1k: '予約数1,000未満',
    sortOptions: {
      new: '新着順',
      sales: '人気順'
    },
    autoConfirm: '即時予約',
    secondConfirm: 'リクエスト予約'

  }
}



// WEBPACK FOOTER //
// ./src/local/ja.js